import React from 'react';
import ComponentCreator from '@docusaurus/ComponentCreator';

export default [
  {
    path: '/docs/about/',
    component: ComponentCreator('/docs/about/', '817'),
    exact: true
  },
  {
    path: '/docs/application-development/',
    component: ComponentCreator('/docs/application-development/', 'ca0'),
    exact: true
  },
  {
    path: '/docs/concepts/reference/glossary/',
    component: ComponentCreator('/docs/concepts/reference/glossary/', '9e6'),
    exact: true
  },
  {
    path: '/docs/leadership/',
    component: ComponentCreator('/docs/leadership/', '6db'),
    exact: true
  },
  {
    path: '/docs/privacy-policy/',
    component: ComponentCreator('/docs/privacy-policy/', '0e2'),
    exact: true
  },
  {
    path: '/docs/search/',
    component: ComponentCreator('/docs/search/', '5fc'),
    exact: true
  },
  {
    path: '/docs/security/',
    component: ComponentCreator('/docs/security/', 'dc6'),
    exact: true
  },
  {
    path: '/docs/',
    component: ComponentCreator('/docs/', '6fa'),
    exact: true
  },
  {
    path: '/docs/',
    component: ComponentCreator('/docs/', '41e'),
    routes: [
      {
        path: '/docs/1.0.0/',
        component: ComponentCreator('/docs/1.0.0/', '36c'),
        routes: [
          {
            path: '/docs/1.0.0/tags/',
            component: ComponentCreator('/docs/1.0.0/tags/', '224'),
            exact: true
          },
          {
            path: '/docs/1.0.0/tags/browser-extension/',
            component: ComponentCreator('/docs/1.0.0/tags/browser-extension/', 'e38'),
            exact: true
          },
          {
            path: '/docs/1.0.0/tags/developer-guide/',
            component: ComponentCreator('/docs/1.0.0/tags/developer-guide/', '645'),
            exact: true
          },
          {
            path: '/docs/1.0.0/tags/examples/',
            component: ComponentCreator('/docs/1.0.0/tags/examples/', '9f6'),
            exact: true
          },
          {
            path: '/docs/1.0.0/tags/explanation/',
            component: ComponentCreator('/docs/1.0.0/tags/explanation/', '99a'),
            exact: true
          },
          {
            path: '/docs/1.0.0/tags/faq/',
            component: ComponentCreator('/docs/1.0.0/tags/faq/', '44e'),
            exact: true
          },
          {
            path: '/docs/1.0.0/tags/go/',
            component: ComponentCreator('/docs/1.0.0/tags/go/', '64a'),
            exact: true
          },
          {
            path: '/docs/1.0.0/tags/hello-world/',
            component: ComponentCreator('/docs/1.0.0/tags/hello-world/', '1b7'),
            exact: true
          },
          {
            path: '/docs/1.0.0/tags/installation-guide/',
            component: ComponentCreator('/docs/1.0.0/tags/installation-guide/', '196'),
            exact: true
          },
          {
            path: '/docs/1.0.0/tags/java/',
            component: ComponentCreator('/docs/1.0.0/tags/java/', '1db'),
            exact: true
          },
          {
            path: '/docs/1.0.0/tags/operation-guide/',
            component: ComponentCreator('/docs/1.0.0/tags/operation-guide/', 'baf'),
            exact: true
          },
          {
            path: '/docs/1.0.0/tags/plugin/',
            component: ComponentCreator('/docs/1.0.0/tags/plugin/', 'e23'),
            exact: true
          },
          {
            path: '/docs/1.0.0/tags/quickstart/',
            component: ComponentCreator('/docs/1.0.0/tags/quickstart/', 'b99'),
            exact: true
          },
          {
            path: '/docs/1.0.0/tags/record-guide/',
            component: ComponentCreator('/docs/1.0.0/tags/record-guide/', '75d'),
            exact: true
          },
          {
            path: '/docs/1.0.0/tags/record-test-case/',
            component: ComponentCreator('/docs/1.0.0/tags/record-test-case/', '021'),
            exact: true
          },
          {
            path: '/docs/1.0.0/tags/record/',
            component: ComponentCreator('/docs/1.0.0/tags/record/', 'e30'),
            exact: true
          },
          {
            path: '/docs/1.0.0/tags/references/',
            component: ComponentCreator('/docs/1.0.0/tags/references/', 'e66'),
            exact: true
          },
          {
            path: '/docs/1.0.0/tags/replay-guide/',
            component: ComponentCreator('/docs/1.0.0/tags/replay-guide/', '64f'),
            exact: true
          },
          {
            path: '/docs/1.0.0/tags/replay-test-case/',
            component: ComponentCreator('/docs/1.0.0/tags/replay-test-case/', '284'),
            exact: true
          },
          {
            path: '/docs/1.0.0/tags/replay-tests/',
            component: ComponentCreator('/docs/1.0.0/tags/replay-tests/', 'a69'),
            exact: true
          },
          {
            path: '/docs/1.0.0/tags/samples/',
            component: ComponentCreator('/docs/1.0.0/tags/samples/', '3ee'),
            exact: true
          },
          {
            path: '/docs/1.0.0/tags/sdk/',
            component: ComponentCreator('/docs/1.0.0/tags/sdk/', 'caf'),
            exact: true
          },
          {
            path: '/docs/1.0.0/tags/server-setup/',
            component: ComponentCreator('/docs/1.0.0/tags/server-setup/', 'a06'),
            exact: true
          },
          {
            path: '/docs/1.0.0/tags/spring-jpa/',
            component: ComponentCreator('/docs/1.0.0/tags/spring-jpa/', '83b'),
            exact: true
          },
          {
            path: '/docs/1.0.0/tags/test/',
            component: ComponentCreator('/docs/1.0.0/tags/test/', 'b43'),
            exact: true
          },
          {
            path: '/docs/1.0.0/tags/tutorial/',
            component: ComponentCreator('/docs/1.0.0/tags/tutorial/', 'faf'),
            exact: true
          },
          {
            path: '/docs/1.0.0/tags/typescript/',
            component: ComponentCreator('/docs/1.0.0/tags/typescript/', '443'),
            exact: true
          },
          {
            path: '/docs/1.0.0/tags/ui/',
            component: ComponentCreator('/docs/1.0.0/tags/ui/', 'f63'),
            exact: true
          },
          {
            path: '/docs/1.0.0/',
            component: ComponentCreator('/docs/1.0.0/', '269'),
            routes: [
              {
                path: '/docs/1.0.0/concepts/',
                component: ComponentCreator('/docs/1.0.0/concepts/', 'eef'),
                exact: true
              },
              {
                path: '/docs/1.0.0/concepts/general-glossary/',
                component: ComponentCreator('/docs/1.0.0/concepts/general-glossary/', '05a'),
                exact: true
              },
              {
                path: '/docs/1.0.0/concepts/reference/glossary-old/',
                component: ComponentCreator('/docs/1.0.0/concepts/reference/glossary-old/', '603'),
                exact: true
              },
              {
                path: '/docs/1.0.0/concepts/reference/glossary/acceptance-testing/',
                component: ComponentCreator('/docs/1.0.0/concepts/reference/glossary/acceptance-testing/', '983'),
                exact: true
              },
              {
                path: '/docs/1.0.0/concepts/reference/glossary/agile-unit-testing/',
                component: ComponentCreator('/docs/1.0.0/concepts/reference/glossary/agile-unit-testing/', '799'),
                exact: true
              },
              {
                path: '/docs/1.0.0/concepts/reference/glossary/behaviour-driven-development/',
                component: ComponentCreator('/docs/1.0.0/concepts/reference/glossary/behaviour-driven-development/', 'e85'),
                exact: true
              },
              {
                path: '/docs/1.0.0/concepts/reference/glossary/beta-testing/',
                component: ComponentCreator('/docs/1.0.0/concepts/reference/glossary/beta-testing/', '392'),
                exact: true
              },
              {
                path: '/docs/1.0.0/concepts/reference/glossary/black-box-testing/',
                component: ComponentCreator('/docs/1.0.0/concepts/reference/glossary/black-box-testing/', '833'),
                exact: true
              },
              {
                path: '/docs/1.0.0/concepts/reference/glossary/code-coverage/',
                component: ComponentCreator('/docs/1.0.0/concepts/reference/glossary/code-coverage/', 'b7e'),
                exact: true
              },
              {
                path: '/docs/1.0.0/concepts/reference/glossary/End-to-end-testing/',
                component: ComponentCreator('/docs/1.0.0/concepts/reference/glossary/End-to-end-testing/', 'daa'),
                exact: true
              },
              {
                path: '/docs/1.0.0/concepts/reference/glossary/functional-testing/',
                component: ComponentCreator('/docs/1.0.0/concepts/reference/glossary/functional-testing/', 'bad'),
                exact: true
              },
              {
                path: '/docs/1.0.0/concepts/reference/glossary/Idempotency/',
                component: ComponentCreator('/docs/1.0.0/concepts/reference/glossary/Idempotency/', '781'),
                exact: true
              },
              {
                path: '/docs/1.0.0/concepts/reference/glossary/Integration-testing/',
                component: ComponentCreator('/docs/1.0.0/concepts/reference/glossary/Integration-testing/', '09e'),
                exact: true
              },
              {
                path: '/docs/1.0.0/concepts/reference/glossary/Mocks/',
                component: ComponentCreator('/docs/1.0.0/concepts/reference/glossary/Mocks/', 'bba'),
                exact: true
              },
              {
                path: '/docs/1.0.0/concepts/reference/glossary/Regression-Testing/',
                component: ComponentCreator('/docs/1.0.0/concepts/reference/glossary/Regression-Testing/', '3ef'),
                exact: true
              },
              {
                path: '/docs/1.0.0/concepts/reference/glossary/Stubs/',
                component: ComponentCreator('/docs/1.0.0/concepts/reference/glossary/Stubs/', '8b6'),
                exact: true
              },
              {
                path: '/docs/1.0.0/concepts/reference/glossary/unit-test-automation/',
                component: ComponentCreator('/docs/1.0.0/concepts/reference/glossary/unit-test-automation/', 'bc2'),
                exact: true
              },
              {
                path: '/docs/1.0.0/concepts/reference/glossary/unit-testing/',
                component: ComponentCreator('/docs/1.0.0/concepts/reference/glossary/unit-testing/', 'a31'),
                exact: true
              },
              {
                path: '/docs/1.0.0/concepts/reference/glossary/white-box-testing/',
                component: ComponentCreator('/docs/1.0.0/concepts/reference/glossary/white-box-testing/', '7c2'),
                exact: true
              },
              {
                path: '/docs/1.0.0/concepts/what-are-keploy-features/',
                component: ComponentCreator('/docs/1.0.0/concepts/what-are-keploy-features/', '1d5'),
                exact: true,
                sidebar: "sidebarInstallation"
              },
              {
                path: '/docs/1.0.0/concepts/what-are-keploy-sdk-modes/',
                component: ComponentCreator('/docs/1.0.0/concepts/what-are-keploy-sdk-modes/', '6e0'),
                exact: true,
                sidebar: "sidebarInstallation"
              },
              {
                path: '/docs/1.0.0/concepts/what-is-keploy-sdk/',
                component: ComponentCreator('/docs/1.0.0/concepts/what-is-keploy-sdk/', '14d'),
                exact: true,
                sidebar: "sidebarInstallation"
              },
              {
                path: '/docs/1.0.0/concepts/what-is-keploy/',
                component: ComponentCreator('/docs/1.0.0/concepts/what-is-keploy/', '840'),
                exact: true,
                sidebar: "sidebarInstallation"
              },
              {
                path: '/docs/1.0.0/devtools/docs-contrib-guide/',
                component: ComponentCreator('/docs/1.0.0/devtools/docs-contrib-guide/', '29a'),
                exact: true
              },
              {
                path: '/docs/1.0.0/devtools/introduction/',
                component: ComponentCreator('/docs/1.0.0/devtools/introduction/', '470'),
                exact: true
              },
              {
                path: '/docs/1.0.0/devtools/sdk-contrib-guide/',
                component: ComponentCreator('/docs/1.0.0/devtools/sdk-contrib-guide/', '96d'),
                exact: true
              },
              {
                path: '/docs/1.0.0/devtools/server-contrib-guide/',
                component: ComponentCreator('/docs/1.0.0/devtools/server-contrib-guide/', 'cfa'),
                exact: true
              },
              {
                path: '/docs/1.0.0/devtools/ui-contrib-guide/',
                component: ComponentCreator('/docs/1.0.0/devtools/ui-contrib-guide/', '76d'),
                exact: true
              },
              {
                path: '/docs/1.0.0/go/installation/',
                component: ComponentCreator('/docs/1.0.0/go/installation/', '153'),
                exact: true,
                sidebar: "sidebarInstallation"
              },
              {
                path: '/docs/1.0.0/go/integration-with-go-test/',
                component: ComponentCreator('/docs/1.0.0/go/integration-with-go-test/', '7a7'),
                exact: true
              },
              {
                path: '/docs/1.0.0/go/integration/',
                component: ComponentCreator('/docs/1.0.0/go/integration/', 'aea'),
                exact: true,
                sidebar: "sidebarInstallation"
              },
              {
                path: '/docs/1.0.0/go/quickstart/',
                component: ComponentCreator('/docs/1.0.0/go/quickstart/', '538'),
                exact: true,
                sidebar: "sidebarInstallation"
              },
              {
                path: '/docs/1.0.0/go/quickstart/echo-sql/',
                component: ComponentCreator('/docs/1.0.0/go/quickstart/echo-sql/', '7f6'),
                exact: true,
                sidebar: "sidebarInstallation"
              },
              {
                path: '/docs/1.0.0/go/quickstart/gin-mongo-2/',
                component: ComponentCreator('/docs/1.0.0/go/quickstart/gin-mongo-2/', 'e71'),
                exact: true,
                sidebar: "sidebarInstallation"
              },
              {
                path: '/docs/1.0.0/go/quickstart/gin-mongo/',
                component: ComponentCreator('/docs/1.0.0/go/quickstart/gin-mongo/', 'f14'),
                exact: true,
                sidebar: "sidebarInstallation"
              },
              {
                path: '/docs/1.0.0/go/quickstart/gorillamux-redis/',
                component: ComponentCreator('/docs/1.0.0/go/quickstart/gorillamux-redis/', '765'),
                exact: true,
                sidebar: "sidebarInstallation"
              },
              {
                path: '/docs/1.0.0/go/record/',
                component: ComponentCreator('/docs/1.0.0/go/record/', 'b77'),
                exact: true,
                sidebar: "sidebarInstallation"
              },
              {
                path: '/docs/1.0.0/go/replay/',
                component: ComponentCreator('/docs/1.0.0/go/replay/', 'e4d'),
                exact: true,
                sidebar: "sidebarInstallation"
              },
              {
                path: '/docs/1.0.0/go/supported-frameworks/',
                component: ComponentCreator('/docs/1.0.0/go/supported-frameworks/', '970'),
                exact: true
              },
              {
                path: '/docs/1.0.0/gsoc/contribution-guide/',
                component: ComponentCreator('/docs/1.0.0/gsoc/contribution-guide/', '920'),
                exact: true
              },
              {
                path: '/docs/1.0.0/hacktoberfest/code-contribution/',
                component: ComponentCreator('/docs/1.0.0/hacktoberfest/code-contribution/', '13e'),
                exact: true
              },
              {
                path: '/docs/1.0.0/hacktoberfest/contribution-guide/',
                component: ComponentCreator('/docs/1.0.0/hacktoberfest/contribution-guide/', '347'),
                exact: true
              },
              {
                path: '/docs/1.0.0/hacktoberfest/no-code-contribution/',
                component: ComponentCreator('/docs/1.0.0/hacktoberfest/no-code-contribution/', '12f'),
                exact: true
              },
              {
                path: '/docs/1.0.0/java/installation/',
                component: ComponentCreator('/docs/1.0.0/java/installation/', 'e73'),
                exact: true,
                sidebar: "sidebarInstallation"
              },
              {
                path: '/docs/1.0.0/java/integration-with-Junit/',
                component: ComponentCreator('/docs/1.0.0/java/integration-with-Junit/', '38d'),
                exact: true
              },
              {
                path: '/docs/1.0.0/java/integration/',
                component: ComponentCreator('/docs/1.0.0/java/integration/', '6aa'),
                exact: true,
                sidebar: "sidebarInstallation"
              },
              {
                path: '/docs/1.0.0/java/quickstart/',
                component: ComponentCreator('/docs/1.0.0/java/quickstart/', 'bcd'),
                exact: true,
                sidebar: "sidebarInstallation"
              },
              {
                path: '/docs/1.0.0/java/quickstart/spring-sql/',
                component: ComponentCreator('/docs/1.0.0/java/quickstart/spring-sql/', 'b81'),
                exact: true,
                sidebar: "sidebarInstallation"
              },
              {
                path: '/docs/1.0.0/java/record/',
                component: ComponentCreator('/docs/1.0.0/java/record/', '039'),
                exact: true,
                sidebar: "sidebarInstallation"
              },
              {
                path: '/docs/1.0.0/java/replay/',
                component: ComponentCreator('/docs/1.0.0/java/replay/', 'cdb'),
                exact: true,
                sidebar: "sidebarInstallation"
              },
              {
                path: '/docs/1.0.0/keploy-explained/faq/',
                component: ComponentCreator('/docs/1.0.0/keploy-explained/faq/', '951'),
                exact: true
              },
              {
                path: '/docs/1.0.0/keploy-explained/how-keploy-works/',
                component: ComponentCreator('/docs/1.0.0/keploy-explained/how-keploy-works/', '006'),
                exact: true,
                sidebar: "sidebarInstallation"
              },
              {
                path: '/docs/1.0.0/keploy-explained/introduction/',
                component: ComponentCreator('/docs/1.0.0/keploy-explained/introduction/', 'e5a'),
                exact: true,
                sidebar: "sidebarInstallation"
              },
              {
                path: '/docs/1.0.0/keploy-explained/why-keploy/',
                component: ComponentCreator('/docs/1.0.0/keploy-explained/why-keploy/', '416'),
                exact: true
              },
              {
                path: '/docs/1.0.0/operation/',
                component: ComponentCreator('/docs/1.0.0/operation/', 'eb1'),
                exact: true,
                sidebar: "sidebarInstallation"
              },
              {
                path: '/docs/1.0.0/operation/browser-extension-operations/',
                component: ComponentCreator('/docs/1.0.0/operation/browser-extension-operations/', 'd84'),
                exact: true,
                sidebar: "sidebarInstallation"
              },
              {
                path: '/docs/1.0.0/operation/record-operations/',
                component: ComponentCreator('/docs/1.0.0/operation/record-operations/', 'fe2'),
                exact: true,
                sidebar: "sidebarInstallation"
              },
              {
                path: '/docs/1.0.0/operation/test-operations/',
                component: ComponentCreator('/docs/1.0.0/operation/test-operations/', '640'),
                exact: true,
                sidebar: "sidebarInstallation"
              },
              {
                path: '/docs/1.0.0/operation/web-ui-operations/',
                component: ComponentCreator('/docs/1.0.0/operation/web-ui-operations/', 'b05'),
                exact: true
              },
              {
                path: '/docs/1.0.0/server/sdk-installation/',
                component: ComponentCreator('/docs/1.0.0/server/sdk-installation/', '9ee'),
                exact: true,
                sidebar: "sidebarInstallation"
              },
              {
                path: '/docs/1.0.0/server/server-installation/',
                component: ComponentCreator('/docs/1.0.0/server/server-installation/', '4c1'),
                exact: true,
                sidebar: "sidebarInstallation"
              },
              {
                path: '/docs/1.0.0/typescript/generate-tests/',
                component: ComponentCreator('/docs/1.0.0/typescript/generate-tests/', '60e'),
                exact: true,
                sidebar: "sidebarInstallation"
              },
              {
                path: '/docs/1.0.0/typescript/installation/',
                component: ComponentCreator('/docs/1.0.0/typescript/installation/', 'be5'),
                exact: true,
                sidebar: "sidebarInstallation"
              },
              {
                path: '/docs/1.0.0/typescript/mock-library/',
                component: ComponentCreator('/docs/1.0.0/typescript/mock-library/', '284'),
                exact: true,
                sidebar: "sidebarInstallation"
              },
              {
                path: '/docs/1.0.0/typescript/supported-frameworks/',
                component: ComponentCreator('/docs/1.0.0/typescript/supported-frameworks/', 'de3'),
                exact: true,
                sidebar: "sidebarInstallation"
              },
              {
                path: '/docs/1.0.0/typescript/testing/',
                component: ComponentCreator('/docs/1.0.0/typescript/testing/', '3f1'),
                exact: true,
                sidebar: "sidebarInstallation"
              }
            ]
          }
        ]
      },
      {
        path: '/docs/2.0.0/',
        component: ComponentCreator('/docs/2.0.0/', 'be4'),
        routes: [
          {
            path: '/docs/2.0.0/tags/',
            component: ComponentCreator('/docs/2.0.0/tags/', 'db0'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/add-application/',
            component: ComponentCreator('/docs/2.0.0/tags/add-application/', 'd59'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/ai/',
            component: ComponentCreator('/docs/2.0.0/tags/ai/', 'bc0'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/api-mocks/',
            component: ComponentCreator('/docs/2.0.0/tags/api-mocks/', '459'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/api-testing/',
            component: ComponentCreator('/docs/2.0.0/tags/api-testing/', '1c7'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/auto-test-generation/',
            component: ComponentCreator('/docs/2.0.0/tags/auto-test-generation/', 'cbf'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/automated-testing/',
            component: ComponentCreator('/docs/2.0.0/tags/automated-testing/', '0b1'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/bdd/',
            component: ComponentCreator('/docs/2.0.0/tags/bdd/', '79e'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/browser-extension/',
            component: ComponentCreator('/docs/2.0.0/tags/browser-extension/', '644'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/bun-js-framework/',
            component: ComponentCreator('/docs/2.0.0/tags/bun-js-framework/', 'db9'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/cd/',
            component: ComponentCreator('/docs/2.0.0/tags/cd/', '4ab'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/ci-guide/',
            component: ComponentCreator('/docs/2.0.0/tags/ci-guide/', 'e94'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/ci/',
            component: ComponentCreator('/docs/2.0.0/tags/ci/', 'cd2'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/cli-commands/',
            component: ComponentCreator('/docs/2.0.0/tags/cli-commands/', 'd79'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/configuration-file/',
            component: ComponentCreator('/docs/2.0.0/tags/configuration-file/', '24f'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/contact/',
            component: ComponentCreator('/docs/2.0.0/tags/contact/', 'a72'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/contributing/',
            component: ComponentCreator('/docs/2.0.0/tags/contributing/', '772'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/contribution-guide/',
            component: ComponentCreator('/docs/2.0.0/tags/contribution-guide/', '923'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/coverage/',
            component: ComponentCreator('/docs/2.0.0/tags/coverage/', 'cf3'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/csharp/',
            component: ComponentCreator('/docs/2.0.0/tags/csharp/', '214'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/custom-mocks/',
            component: ComponentCreator('/docs/2.0.0/tags/custom-mocks/', 'b6d'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/debugger-guide/',
            component: ComponentCreator('/docs/2.0.0/tags/debugger-guide/', '4b3'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/dev-guide/',
            component: ComponentCreator('/docs/2.0.0/tags/dev-guide/', 'b11'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/docker-tls/',
            component: ComponentCreator('/docs/2.0.0/tags/docker-tls/', '004'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/docker/',
            component: ComponentCreator('/docs/2.0.0/tags/docker/', '657'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/dotnet-framework/',
            component: ComponentCreator('/docs/2.0.0/tags/dotnet-framework/', '7eb'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/ebpf/',
            component: ComponentCreator('/docs/2.0.0/tags/ebpf/', '07d'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/examples/',
            component: ComponentCreator('/docs/2.0.0/tags/examples/', 'd8d'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/explanation/',
            component: ComponentCreator('/docs/2.0.0/tags/explanation/', '065'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/expressjs/',
            component: ComponentCreator('/docs/2.0.0/tags/expressjs/', 'f1a'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/faq/',
            component: ComponentCreator('/docs/2.0.0/tags/faq/', 'bb0'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/fast-api-framework/',
            component: ComponentCreator('/docs/2.0.0/tags/fast-api-framework/', '9c8'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/fasthttp/',
            component: ComponentCreator('/docs/2.0.0/tags/fasthttp/', '402'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/feature-guide/',
            component: ComponentCreator('/docs/2.0.0/tags/feature-guide/', '99c'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/features/',
            component: ComponentCreator('/docs/2.0.0/tags/features/', '456'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/flask-framework/',
            component: ComponentCreator('/docs/2.0.0/tags/flask-framework/', '66b'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/flask/',
            component: ComponentCreator('/docs/2.0.0/tags/flask/', '9e2'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/functional-testing/',
            component: ComponentCreator('/docs/2.0.0/tags/functional-testing/', '991'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/generate-test-cases/',
            component: ComponentCreator('/docs/2.0.0/tags/generate-test-cases/', '2a4'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/generate-unit-test/',
            component: ComponentCreator('/docs/2.0.0/tags/generate-unit-test/', '0ab'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/gin-framework/',
            component: ComponentCreator('/docs/2.0.0/tags/gin-framework/', 'b14'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/glossary/',
            component: ComponentCreator('/docs/2.0.0/tags/glossary/', '3dc'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/go/',
            component: ComponentCreator('/docs/2.0.0/tags/go/', 'b8c'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/graph-ql/',
            component: ComponentCreator('/docs/2.0.0/tags/graph-ql/', '169'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/hello-world/',
            component: ComponentCreator('/docs/2.0.0/tags/hello-world/', '2e9'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/install/',
            component: ComponentCreator('/docs/2.0.0/tags/install/', 'c64'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/installation-guide/',
            component: ComponentCreator('/docs/2.0.0/tags/installation-guide/', 'ec4'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/installation/',
            component: ComponentCreator('/docs/2.0.0/tags/installation/', '200'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/introduction/',
            component: ComponentCreator('/docs/2.0.0/tags/introduction/', '552'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/java-framework/',
            component: ComponentCreator('/docs/2.0.0/tags/java-framework/', 'd50'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/java/',
            component: ComponentCreator('/docs/2.0.0/tags/java/', 'd7b'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/javascript/',
            component: ComponentCreator('/docs/2.0.0/tags/javascript/', '8f8'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/js/',
            component: ComponentCreator('/docs/2.0.0/tags/js/', '628'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/jwt/',
            component: ComponentCreator('/docs/2.0.0/tags/jwt/', '48e'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/keploy-cloud/',
            component: ComponentCreator('/docs/2.0.0/tags/keploy-cloud/', '8b6'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/keploy-console/',
            component: ComponentCreator('/docs/2.0.0/tags/keploy-console/', 'cd5'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/keploy-features/',
            component: ComponentCreator('/docs/2.0.0/tags/keploy-features/', '01c'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/keploy-karaf/',
            component: ComponentCreator('/docs/2.0.0/tags/keploy-karaf/', 'e38'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/keploy-passthrough/',
            component: ComponentCreator('/docs/2.0.0/tags/keploy-passthrough/', 'fa8'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/keploy-templatize/',
            component: ComponentCreator('/docs/2.0.0/tags/keploy-templatize/', 'f58'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/keploy/',
            component: ComponentCreator('/docs/2.0.0/tags/keploy/', 'fa8'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/limitations/',
            component: ComponentCreator('/docs/2.0.0/tags/limitations/', 'fb0'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/linux/',
            component: ComponentCreator('/docs/2.0.0/tags/linux/', 'b82'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/macos/',
            component: ComponentCreator('/docs/2.0.0/tags/macos/', '25f'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/manual-testing/',
            component: ComponentCreator('/docs/2.0.0/tags/manual-testing/', '9c0'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/mock-mutations/',
            component: ComponentCreator('/docs/2.0.0/tags/mock-mutations/', '888'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/mock-storage/',
            component: ComponentCreator('/docs/2.0.0/tags/mock-storage/', '90b'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/mock-with-test/',
            component: ComponentCreator('/docs/2.0.0/tags/mock-with-test/', '926'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/mocks/',
            component: ComponentCreator('/docs/2.0.0/tags/mocks/', '9a5'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/mongo-db/',
            component: ComponentCreator('/docs/2.0.0/tags/mongo-db/', '3df'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/mongo/',
            component: ComponentCreator('/docs/2.0.0/tags/mongo/', '903'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/mongodb/',
            component: ComponentCreator('/docs/2.0.0/tags/mongodb/', '623'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/mux-framework/',
            component: ComponentCreator('/docs/2.0.0/tags/mux-framework/', '1f3'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/mysql/',
            component: ComponentCreator('/docs/2.0.0/tags/mysql/', 'f12'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/new-application/',
            component: ComponentCreator('/docs/2.0.0/tags/new-application/', 'f75'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/next-js/',
            component: ComponentCreator('/docs/2.0.0/tags/next-js/', 'a35'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/nhost/',
            component: ComponentCreator('/docs/2.0.0/tags/nhost/', 'adf'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/node/',
            component: ComponentCreator('/docs/2.0.0/tags/node/', 'd5b'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/nodejs/',
            component: ComponentCreator('/docs/2.0.0/tags/nodejs/', '4cc'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/npm/',
            component: ComponentCreator('/docs/2.0.0/tags/npm/', '4bd'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/open-ai/',
            component: ComponentCreator('/docs/2.0.0/tags/open-ai/', '1c6'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/open-api/',
            component: ComponentCreator('/docs/2.0.0/tags/open-api/', 'b5c'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/openhospital/',
            component: ComponentCreator('/docs/2.0.0/tags/openhospital/', '772'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/operation-guide/',
            component: ComponentCreator('/docs/2.0.0/tags/operation-guide/', '229'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/petclinic/',
            component: ComponentCreator('/docs/2.0.0/tags/petclinic/', 'b0d'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/plugin/',
            component: ComponentCreator('/docs/2.0.0/tags/plugin/', '9ed'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/postgres/',
            component: ComponentCreator('/docs/2.0.0/tags/postgres/', 'b04'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/pytest/',
            component: ComponentCreator('/docs/2.0.0/tags/pytest/', '69e'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/python-framework/',
            component: ComponentCreator('/docs/2.0.0/tags/python-framework/', '71c'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/python/',
            component: ComponentCreator('/docs/2.0.0/tags/python/', 'f7e'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/quickstart/',
            component: ComponentCreator('/docs/2.0.0/tags/quickstart/', '142'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/react/',
            component: ComponentCreator('/docs/2.0.0/tags/react/', 'b77'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/record-guide/',
            component: ComponentCreator('/docs/2.0.0/tags/record-guide/', 'd2b'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/record-replay-test/',
            component: ComponentCreator('/docs/2.0.0/tags/record-replay-test/', 'd79'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/record-test-case/',
            component: ComponentCreator('/docs/2.0.0/tags/record-test-case/', '785'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/record/',
            component: ComponentCreator('/docs/2.0.0/tags/record/', '6ee'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/redis/',
            component: ComponentCreator('/docs/2.0.0/tags/redis/', '9f0'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/reference/',
            component: ComponentCreator('/docs/2.0.0/tags/reference/', '62f'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/references/',
            component: ComponentCreator('/docs/2.0.0/tags/references/', '355'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/rename-testcases/',
            component: ComponentCreator('/docs/2.0.0/tags/rename-testcases/', 'd70'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/rename-testsets/',
            component: ComponentCreator('/docs/2.0.0/tags/rename-testsets/', '857'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/replay-guide/',
            component: ComponentCreator('/docs/2.0.0/tags/replay-guide/', 'd34'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/replay-test-case/',
            component: ComponentCreator('/docs/2.0.0/tags/replay-test-case/', '2cc'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/replay-tests/',
            component: ComponentCreator('/docs/2.0.0/tags/replay-tests/', '683'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/rest-api/',
            component: ComponentCreator('/docs/2.0.0/tags/rest-api/', '1a9'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/restful-api/',
            component: ComponentCreator('/docs/2.0.0/tags/restful-api/', 'ced'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/running-guide/',
            component: ComponentCreator('/docs/2.0.0/tags/running-guide/', '7d0'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/rust/',
            component: ComponentCreator('/docs/2.0.0/tags/rust/', '343'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/samples/',
            component: ComponentCreator('/docs/2.0.0/tags/samples/', 'b30'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/sanic/',
            component: ComponentCreator('/docs/2.0.0/tags/sanic/', '05c'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/self-written-mocks/',
            component: ComponentCreator('/docs/2.0.0/tags/self-written-mocks/', '7a8'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/server-setup/',
            component: ComponentCreator('/docs/2.0.0/tags/server-setup/', '2c0'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/sms/',
            component: ComponentCreator('/docs/2.0.0/tags/sms/', '450'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/spring-boot/',
            component: ComponentCreator('/docs/2.0.0/tags/spring-boot/', '2de'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/spring-jpa/',
            component: ComponentCreator('/docs/2.0.0/tags/spring-jpa/', '244'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/springboot/',
            component: ComponentCreator('/docs/2.0.0/tags/springboot/', '595'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/sql/',
            component: ComponentCreator('/docs/2.0.0/tags/sql/', '490'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/sse/',
            component: ComponentCreator('/docs/2.0.0/tags/sse/', '319'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/support/',
            component: ComponentCreator('/docs/2.0.0/tags/support/', 'b59'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/svelte/',
            component: ComponentCreator('/docs/2.0.0/tags/svelte/', '799'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/test-automation/',
            component: ComponentCreator('/docs/2.0.0/tags/test-automation/', '86f'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/test-deduplication/',
            component: ComponentCreator('/docs/2.0.0/tags/test-deduplication/', 'ccf'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/test-scripts/',
            component: ComponentCreator('/docs/2.0.0/tags/test-scripts/', 'ea3'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/test/',
            component: ComponentCreator('/docs/2.0.0/tags/test/', 'acb'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/testing/',
            component: ComponentCreator('/docs/2.0.0/tags/testing/', '653'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/time-sensitive-fields/',
            component: ComponentCreator('/docs/2.0.0/tags/time-sensitive-fields/', '5a9'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/tutorial/',
            component: ComponentCreator('/docs/2.0.0/tags/tutorial/', '292'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/twilio/',
            component: ComponentCreator('/docs/2.0.0/tags/twilio/', 'b0c'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/typescript/',
            component: ComponentCreator('/docs/2.0.0/tags/typescript/', '024'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/ui/',
            component: ComponentCreator('/docs/2.0.0/tags/ui/', '4b0'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/unit-test-generator/',
            component: ComponentCreator('/docs/2.0.0/tags/unit-test-generator/', 'ad0'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/unit-test/',
            component: ComponentCreator('/docs/2.0.0/tags/unit-test/', 'bd7'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/utg/',
            component: ComponentCreator('/docs/2.0.0/tags/utg/', '5fc'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/what-is-keploy/',
            component: ComponentCreator('/docs/2.0.0/tags/what-is-keploy/', 'ac9'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/why-keploy/',
            component: ComponentCreator('/docs/2.0.0/tags/why-keploy/', 'c82'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/windows/',
            component: ComponentCreator('/docs/2.0.0/tags/windows/', '7ec'),
            exact: true
          },
          {
            path: '/docs/2.0.0/tags/xml/',
            component: ComponentCreator('/docs/2.0.0/tags/xml/', '9f2'),
            exact: true
          },
          {
            path: '/docs/2.0.0/',
            component: ComponentCreator('/docs/2.0.0/', 'd78'),
            routes: [
              {
                path: '/docs/2.0.0/ci-cd/github/',
                component: ComponentCreator('/docs/2.0.0/ci-cd/github/', '3e8'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/2.0.0/ci-cd/gitlab/',
                component: ComponentCreator('/docs/2.0.0/ci-cd/gitlab/', 'b87'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/2.0.0/ci-cd/jenkins/',
                component: ComponentCreator('/docs/2.0.0/ci-cd/jenkins/', 'a1c'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/2.0.0/concepts/',
                component: ComponentCreator('/docs/2.0.0/concepts/', 'cde'),
                exact: true
              },
              {
                path: '/docs/2.0.0/concepts/general-glossary/',
                component: ComponentCreator('/docs/2.0.0/concepts/general-glossary/', '6c9'),
                exact: true
              },
              {
                path: '/docs/2.0.0/concepts/installation/',
                component: ComponentCreator('/docs/2.0.0/concepts/installation/', '50b'),
                exact: true
              },
              {
                path: '/docs/2.0.0/concepts/platform-requirements/',
                component: ComponentCreator('/docs/2.0.0/concepts/platform-requirements/', '551'),
                exact: true
              },
              {
                path: '/docs/2.0.0/concepts/reference/glossary/acceptance-testing/',
                component: ComponentCreator('/docs/2.0.0/concepts/reference/glossary/acceptance-testing/', '807'),
                exact: true
              },
              {
                path: '/docs/2.0.0/concepts/reference/glossary/agile-unit-testing/',
                component: ComponentCreator('/docs/2.0.0/concepts/reference/glossary/agile-unit-testing/', '17d'),
                exact: true
              },
              {
                path: '/docs/2.0.0/concepts/reference/glossary/ai-test-completion/',
                component: ComponentCreator('/docs/2.0.0/concepts/reference/glossary/ai-test-completion/', '7e7'),
                exact: true
              },
              {
                path: '/docs/2.0.0/concepts/reference/glossary/behaviour-driven-development/',
                component: ComponentCreator('/docs/2.0.0/concepts/reference/glossary/behaviour-driven-development/', '04e'),
                exact: true
              },
              {
                path: '/docs/2.0.0/concepts/reference/glossary/beta-testing/',
                component: ComponentCreator('/docs/2.0.0/concepts/reference/glossary/beta-testing/', '908'),
                exact: true
              },
              {
                path: '/docs/2.0.0/concepts/reference/glossary/black-box-testing/',
                component: ComponentCreator('/docs/2.0.0/concepts/reference/glossary/black-box-testing/', '23a'),
                exact: true
              },
              {
                path: '/docs/2.0.0/concepts/reference/glossary/code-coverage/',
                component: ComponentCreator('/docs/2.0.0/concepts/reference/glossary/code-coverage/', '1c2'),
                exact: true
              },
              {
                path: '/docs/2.0.0/concepts/reference/glossary/cucumber-testing/',
                component: ComponentCreator('/docs/2.0.0/concepts/reference/glossary/cucumber-testing/', '76d'),
                exact: true
              },
              {
                path: '/docs/2.0.0/concepts/reference/glossary/end-to-end-testing/',
                component: ComponentCreator('/docs/2.0.0/concepts/reference/glossary/end-to-end-testing/', '898'),
                exact: true
              },
              {
                path: '/docs/2.0.0/concepts/reference/glossary/error-guessing/',
                component: ComponentCreator('/docs/2.0.0/concepts/reference/glossary/error-guessing/', '176'),
                exact: true
              },
              {
                path: '/docs/2.0.0/concepts/reference/glossary/functional-testing/',
                component: ComponentCreator('/docs/2.0.0/concepts/reference/glossary/functional-testing/', '077'),
                exact: true
              },
              {
                path: '/docs/2.0.0/concepts/reference/glossary/gray-box-testing/',
                component: ComponentCreator('/docs/2.0.0/concepts/reference/glossary/gray-box-testing/', '9dc'),
                exact: true
              },
              {
                path: '/docs/2.0.0/concepts/reference/glossary/idempotency/',
                component: ComponentCreator('/docs/2.0.0/concepts/reference/glossary/idempotency/', '069'),
                exact: true
              },
              {
                path: '/docs/2.0.0/concepts/reference/glossary/integration-testing/',
                component: ComponentCreator('/docs/2.0.0/concepts/reference/glossary/integration-testing/', '66a'),
                exact: true
              },
              {
                path: '/docs/2.0.0/concepts/reference/glossary/manual-testing/',
                component: ComponentCreator('/docs/2.0.0/concepts/reference/glossary/manual-testing/', 'cea'),
                exact: true
              },
              {
                path: '/docs/2.0.0/concepts/reference/glossary/microservice-testing/',
                component: ComponentCreator('/docs/2.0.0/concepts/reference/glossary/microservice-testing/', '7f7'),
                exact: true
              },
              {
                path: '/docs/2.0.0/concepts/reference/glossary/mocks/',
                component: ComponentCreator('/docs/2.0.0/concepts/reference/glossary/mocks/', '1c3'),
                exact: true
              },
              {
                path: '/docs/2.0.0/concepts/reference/glossary/performance-testing/',
                component: ComponentCreator('/docs/2.0.0/concepts/reference/glossary/performance-testing/', '8c7'),
                exact: true
              },
              {
                path: '/docs/2.0.0/concepts/reference/glossary/regression-testing/',
                component: ComponentCreator('/docs/2.0.0/concepts/reference/glossary/regression-testing/', 'a0f'),
                exact: true
              },
              {
                path: '/docs/2.0.0/concepts/reference/glossary/software-testing-life-cycle/',
                component: ComponentCreator('/docs/2.0.0/concepts/reference/glossary/software-testing-life-cycle/', 'ef6'),
                exact: true
              },
              {
                path: '/docs/2.0.0/concepts/reference/glossary/stubs/',
                component: ComponentCreator('/docs/2.0.0/concepts/reference/glossary/stubs/', 'b3e'),
                exact: true
              },
              {
                path: '/docs/2.0.0/concepts/reference/glossary/test-data-generation/',
                component: ComponentCreator('/docs/2.0.0/concepts/reference/glossary/test-data-generation/', '3f3'),
                exact: true
              },
              {
                path: '/docs/2.0.0/concepts/reference/glossary/test-driven-development/',
                component: ComponentCreator('/docs/2.0.0/concepts/reference/glossary/test-driven-development/', 'aac'),
                exact: true
              },
              {
                path: '/docs/2.0.0/concepts/reference/glossary/unit-test-automation/',
                component: ComponentCreator('/docs/2.0.0/concepts/reference/glossary/unit-test-automation/', 'ff0'),
                exact: true
              },
              {
                path: '/docs/2.0.0/concepts/reference/glossary/unit-testing/',
                component: ComponentCreator('/docs/2.0.0/concepts/reference/glossary/unit-testing/', '76b'),
                exact: true
              },
              {
                path: '/docs/2.0.0/concepts/reference/glossary/white-box-testing/',
                component: ComponentCreator('/docs/2.0.0/concepts/reference/glossary/white-box-testing/', 'a90'),
                exact: true
              },
              {
                path: '/docs/2.0.0/concepts/support/',
                component: ComponentCreator('/docs/2.0.0/concepts/support/', 'f3b'),
                exact: true
              },
              {
                path: '/docs/2.0.0/concepts/what-are-keploy-features/',
                component: ComponentCreator('/docs/2.0.0/concepts/what-are-keploy-features/', '434'),
                exact: true
              },
              {
                path: '/docs/2.0.0/concepts/what-is-keploy-ebpf/',
                component: ComponentCreator('/docs/2.0.0/concepts/what-is-keploy-ebpf/', 'a35'),
                exact: true
              },
              {
                path: '/docs/2.0.0/concepts/what-is-keploy/',
                component: ComponentCreator('/docs/2.0.0/concepts/what-is-keploy/', 'd02'),
                exact: true
              },
              {
                path: '/docs/2.0.0/dependencies/',
                component: ComponentCreator('/docs/2.0.0/dependencies/', '60b'),
                exact: true
              },
              {
                path: '/docs/2.0.0/dependencies/http/',
                component: ComponentCreator('/docs/2.0.0/dependencies/http/', 'fcf'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/2.0.0/dependencies/mongo/',
                component: ComponentCreator('/docs/2.0.0/dependencies/mongo/', '1ea'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/2.0.0/dependencies/postgres/',
                component: ComponentCreator('/docs/2.0.0/dependencies/postgres/', 'b62'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/2.0.0/dependencies/redis/',
                component: ComponentCreator('/docs/2.0.0/dependencies/redis/', '631'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/2.0.0/gsoc/contribution-guide/',
                component: ComponentCreator('/docs/2.0.0/gsoc/contribution-guide/', '5fc'),
                exact: true
              },
              {
                path: '/docs/2.0.0/hacktoberfest/code-contribution/',
                component: ComponentCreator('/docs/2.0.0/hacktoberfest/code-contribution/', '0f5'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/2.0.0/hacktoberfest/contribution-guide/',
                component: ComponentCreator('/docs/2.0.0/hacktoberfest/contribution-guide/', 'f1d'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/2.0.0/hacktoberfest/no-code-contribution/',
                component: ComponentCreator('/docs/2.0.0/hacktoberfest/no-code-contribution/', '7d9'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/2.0.0/keploy-cloud/application-settings/',
                component: ComponentCreator('/docs/2.0.0/keploy-cloud/application-settings/', 'd36'),
                exact: true
              },
              {
                path: '/docs/2.0.0/keploy-cloud/auto-test-generation/',
                component: ComponentCreator('/docs/2.0.0/keploy-cloud/auto-test-generation/', 'f66'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/2.0.0/keploy-cloud/cloud-installation/',
                component: ComponentCreator('/docs/2.0.0/keploy-cloud/cloud-installation/', '7d8'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/2.0.0/keploy-cloud/deduplication/',
                component: ComponentCreator('/docs/2.0.0/keploy-cloud/deduplication/', 'db3'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/2.0.0/keploy-cloud/keploy-console/',
                component: ComponentCreator('/docs/2.0.0/keploy-cloud/keploy-console/', '96a'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/2.0.0/keploy-cloud/mock-registry/',
                component: ComponentCreator('/docs/2.0.0/keploy-cloud/mock-registry/', '437'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/2.0.0/keploy-cloud/time-freezing/',
                component: ComponentCreator('/docs/2.0.0/keploy-cloud/time-freezing/', '93a'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/2.0.0/keploy-explained/common-errors/',
                component: ComponentCreator('/docs/2.0.0/keploy-explained/common-errors/', 'bf1'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/2.0.0/keploy-explained/contribution-guide/',
                component: ComponentCreator('/docs/2.0.0/keploy-explained/contribution-guide/', '0f0'),
                exact: true,
                sidebar: "sidebarContributionGuide"
              },
              {
                path: '/docs/2.0.0/keploy-explained/debugger-guide/',
                component: ComponentCreator('/docs/2.0.0/keploy-explained/debugger-guide/', '126'),
                exact: true,
                sidebar: "sidebarContributionGuide"
              },
              {
                path: '/docs/2.0.0/keploy-explained/docs-dev-guide/',
                component: ComponentCreator('/docs/2.0.0/keploy-explained/docs-dev-guide/', 'e03'),
                exact: true,
                sidebar: "sidebarContributionGuide"
              },
              {
                path: '/docs/2.0.0/keploy-explained/faq/',
                component: ComponentCreator('/docs/2.0.0/keploy-explained/faq/', '0c2'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/2.0.0/keploy-explained/how-keploy-works/',
                component: ComponentCreator('/docs/2.0.0/keploy-explained/how-keploy-works/', 'c32'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/2.0.0/keploy-explained/introduction/',
                component: ComponentCreator('/docs/2.0.0/keploy-explained/introduction/', 'c29'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/2.0.0/keploy-explained/mac-linux/',
                component: ComponentCreator('/docs/2.0.0/keploy-explained/mac-linux/', '048'),
                exact: true,
                sidebar: "sidebarContributionGuide"
              },
              {
                path: '/docs/2.0.0/keploy-explained/testing-guide/',
                component: ComponentCreator('/docs/2.0.0/keploy-explained/testing-guide/', '88d'),
                exact: true,
                sidebar: "sidebarContributionGuide"
              },
              {
                path: '/docs/2.0.0/keploy-explained/why-keploy/',
                component: ComponentCreator('/docs/2.0.0/keploy-explained/why-keploy/', '664'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/2.0.0/operation/',
                component: ComponentCreator('/docs/2.0.0/operation/', '41e'),
                exact: true
              },
              {
                path: '/docs/2.0.0/operation/browser-extension-operations/',
                component: ComponentCreator('/docs/2.0.0/operation/browser-extension-operations/', '857'),
                exact: true
              },
              {
                path: '/docs/2.0.0/operation/record-operations/',
                component: ComponentCreator('/docs/2.0.0/operation/record-operations/', '013'),
                exact: true
              },
              {
                path: '/docs/2.0.0/operation/test-operations/',
                component: ComponentCreator('/docs/2.0.0/operation/test-operations/', '0e0'),
                exact: true
              },
              {
                path: '/docs/2.0.0/operation/web-ui-operations/',
                component: ComponentCreator('/docs/2.0.0/operation/web-ui-operations/', '766'),
                exact: true
              },
              {
                path: '/docs/2.0.0/quickstart/crud-nodejs/',
                component: ComponentCreator('/docs/2.0.0/quickstart/crud-nodejs/', 'ffa'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/2.0.0/quickstart/express-mongoose-application/',
                component: ComponentCreator('/docs/2.0.0/quickstart/express-mongoose-application/', '9d2'),
                exact: true
              },
              {
                path: '/docs/2.0.0/quickstart/express-postgresql-prisma/',
                component: ComponentCreator('/docs/2.0.0/quickstart/express-postgresql-prisma/', '338'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/2.0.0/quickstart/flask-redis/',
                component: ComponentCreator('/docs/2.0.0/quickstart/flask-redis/', 'f5a'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/2.0.0/quickstart/java-spring-boot-mongo/',
                component: ComponentCreator('/docs/2.0.0/quickstart/java-spring-boot-mongo/', 'cd7'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/2.0.0/quickstart/java-spring-boot-xml/',
                component: ComponentCreator('/docs/2.0.0/quickstart/java-spring-boot-xml/', 'cca'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/2.0.0/quickstart/openhospital/',
                component: ComponentCreator('/docs/2.0.0/quickstart/openhospital/', '817'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/2.0.0/quickstart/pet-clinic/',
                component: ComponentCreator('/docs/2.0.0/quickstart/pet-clinic/', '948'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/2.0.0/quickstart/sample-rust-crud-mongo/',
                component: ComponentCreator('/docs/2.0.0/quickstart/sample-rust-crud-mongo/', 'c59'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/2.0.0/quickstart/samples-bunjs/',
                component: ComponentCreator('/docs/2.0.0/quickstart/samples-bunjs/', '8ab'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/2.0.0/quickstart/samples-csharp/',
                component: ComponentCreator('/docs/2.0.0/quickstart/samples-csharp/', 'eb9'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/2.0.0/quickstart/samples-django/',
                component: ComponentCreator('/docs/2.0.0/quickstart/samples-django/', '953'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/2.0.0/quickstart/samples-echo/',
                component: ComponentCreator('/docs/2.0.0/quickstart/samples-echo/', 'ec5'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/2.0.0/quickstart/samples-fastapi-twilio/',
                component: ComponentCreator('/docs/2.0.0/quickstart/samples-fastapi-twilio/', 'ae9'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/2.0.0/quickstart/samples-fastapi/',
                component: ComponentCreator('/docs/2.0.0/quickstart/samples-fastapi/', 'ff5'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/2.0.0/quickstart/samples-fasthttp/',
                component: ComponentCreator('/docs/2.0.0/quickstart/samples-fasthttp/', '51f'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/2.0.0/quickstart/samples-flask/',
                component: ComponentCreator('/docs/2.0.0/quickstart/samples-flask/', 'a9b'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/2.0.0/quickstart/samples-gin/',
                component: ComponentCreator('/docs/2.0.0/quickstart/samples-gin/', 'a0d'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/2.0.0/quickstart/samples-java/',
                component: ComponentCreator('/docs/2.0.0/quickstart/samples-java/', 'a62'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/2.0.0/quickstart/samples-mux/',
                component: ComponentCreator('/docs/2.0.0/quickstart/samples-mux/', 'c4f'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/2.0.0/quickstart/samples-mysql/',
                component: ComponentCreator('/docs/2.0.0/quickstart/samples-mysql/', 'baa'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/2.0.0/quickstart/samples-nextjs/',
                component: ComponentCreator('/docs/2.0.0/quickstart/samples-nextjs/', '8ad'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/2.0.0/quickstart/samples-node-jwt/',
                component: ComponentCreator('/docs/2.0.0/quickstart/samples-node-jwt/', '526'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/2.0.0/quickstart/samples-nodejs/',
                component: ComponentCreator('/docs/2.0.0/quickstart/samples-nodejs/', 'e44'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/2.0.0/quickstart/samples-redis/',
                component: ComponentCreator('/docs/2.0.0/quickstart/samples-redis/', '129'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/2.0.0/quickstart/samples-rust-wrap/',
                component: ComponentCreator('/docs/2.0.0/quickstart/samples-rust-wrap/', '4ea'),
                exact: true
              },
              {
                path: '/docs/2.0.0/quickstart/samples-rust/',
                component: ComponentCreator('/docs/2.0.0/quickstart/samples-rust/', 'f99'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/2.0.0/quickstart/samples-sse/',
                component: ComponentCreator('/docs/2.0.0/quickstart/samples-sse/', '417'),
                exact: true
              },
              {
                path: '/docs/2.0.0/quickstart/samples-typescript/',
                component: ComponentCreator('/docs/2.0.0/quickstart/samples-typescript/', 'd48'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/2.0.0/quickstart/sanic-mongo/',
                component: ComponentCreator('/docs/2.0.0/quickstart/sanic-mongo/', '379'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/2.0.0/running-keploy/api-test-generator/',
                component: ComponentCreator('/docs/2.0.0/running-keploy/api-test-generator/', '4d5'),
                exact: true
              },
              {
                path: '/docs/2.0.0/running-keploy/cli-commands/',
                component: ComponentCreator('/docs/2.0.0/running-keploy/cli-commands/', '61d'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/2.0.0/running-keploy/configuration-file/',
                component: ComponentCreator('/docs/2.0.0/running-keploy/configuration-file/', '75f'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/2.0.0/running-keploy/custom-mocks/',
                component: ComponentCreator('/docs/2.0.0/running-keploy/custom-mocks/', 'db2'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/2.0.0/running-keploy/docker-tls/',
                component: ComponentCreator('/docs/2.0.0/running-keploy/docker-tls/', '217'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/2.0.0/running-keploy/keploy-karaf-example/',
                component: ComponentCreator('/docs/2.0.0/running-keploy/keploy-karaf-example/', '1e4'),
                exact: true
              },
              {
                path: '/docs/2.0.0/running-keploy/keploy-passthrough/',
                component: ComponentCreator('/docs/2.0.0/running-keploy/keploy-passthrough/', '3de'),
                exact: true
              },
              {
                path: '/docs/2.0.0/running-keploy/keploy-templatize/',
                component: ComponentCreator('/docs/2.0.0/running-keploy/keploy-templatize/', '688'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/2.0.0/running-keploy/rename-testcases/',
                component: ComponentCreator('/docs/2.0.0/running-keploy/rename-testcases/', '698'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/2.0.0/running-keploy/unit-test-generator/',
                component: ComponentCreator('/docs/2.0.0/running-keploy/unit-test-generator/', '8f6'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/2.0.0/server/',
                component: ComponentCreator('/docs/2.0.0/server/', 'f0d'),
                exact: true
              },
              {
                path: '/docs/2.0.0/server/installation/',
                component: ComponentCreator('/docs/2.0.0/server/installation/', '9f1'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/2.0.0/server/linux/installation/',
                component: ComponentCreator('/docs/2.0.0/server/linux/installation/', '087'),
                exact: true
              },
              {
                path: '/docs/2.0.0/server/macos/installation/',
                component: ComponentCreator('/docs/2.0.0/server/macos/installation/', 'c46'),
                exact: true
              },
              {
                path: '/docs/2.0.0/server/sdk-installation/',
                component: ComponentCreator('/docs/2.0.0/server/sdk-installation/', '300'),
                exact: true
              },
              {
                path: '/docs/2.0.0/server/sdk-installation/go/',
                component: ComponentCreator('/docs/2.0.0/server/sdk-installation/go/', '72e'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/2.0.0/server/sdk-installation/java/',
                component: ComponentCreator('/docs/2.0.0/server/sdk-installation/java/', 'c04'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/2.0.0/server/sdk-installation/javascript/',
                component: ComponentCreator('/docs/2.0.0/server/sdk-installation/javascript/', 'e91'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/2.0.0/server/sdk-installation/python/',
                component: ComponentCreator('/docs/2.0.0/server/sdk-installation/python/', '617'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/2.0.0/server/windows/installation/',
                component: ComponentCreator('/docs/2.0.0/server/windows/installation/', '4d7'),
                exact: true
              }
            ]
          }
        ]
      },
      {
        path: '/docs/',
        component: ComponentCreator('/docs/', '0ed'),
        routes: [
          {
            path: '/docs/tags/',
            component: ComponentCreator('/docs/tags/', 'dc9'),
            exact: true
          },
          {
            path: '/docs/tags/access-control/',
            component: ComponentCreator('/docs/tags/access-control/', '49b'),
            exact: true
          },
          {
            path: '/docs/tags/add-application/',
            component: ComponentCreator('/docs/tags/add-application/', 'e39'),
            exact: true
          },
          {
            path: '/docs/tags/ai-agent/',
            component: ComponentCreator('/docs/tags/ai-agent/', '3d4'),
            exact: true
          },
          {
            path: '/docs/tags/ai-agents/',
            component: ComponentCreator('/docs/tags/ai-agents/', 'd21'),
            exact: true
          },
          {
            path: '/docs/tags/ai-automation/',
            component: ComponentCreator('/docs/tags/ai-automation/', '0e3'),
            exact: true
          },
          {
            path: '/docs/tags/ai-testing/',
            component: ComponentCreator('/docs/tags/ai-testing/', '6e4'),
            exact: true
          },
          {
            path: '/docs/tags/ai/',
            component: ComponentCreator('/docs/tags/ai/', 'df6'),
            exact: true
          },
          {
            path: '/docs/tags/antigravity/',
            component: ComponentCreator('/docs/tags/antigravity/', '275'),
            exact: true
          },
          {
            path: '/docs/tags/api-key/',
            component: ComponentCreator('/docs/tags/api-key/', 'ab6'),
            exact: true
          },
          {
            path: '/docs/tags/api-mocks/',
            component: ComponentCreator('/docs/tags/api-mocks/', 'd79'),
            exact: true
          },
          {
            path: '/docs/tags/api-testing/',
            component: ComponentCreator('/docs/tags/api-testing/', 'f03'),
            exact: true
          },
          {
            path: '/docs/tags/api/',
            component: ComponentCreator('/docs/tags/api/', '670'),
            exact: true
          },
          {
            path: '/docs/tags/architecture/',
            component: ComponentCreator('/docs/tags/architecture/', '044'),
            exact: true
          },
          {
            path: '/docs/tags/argocd/',
            component: ComponentCreator('/docs/tags/argocd/', 'b26'),
            exact: true
          },
          {
            path: '/docs/tags/assertion-tree/',
            component: ComponentCreator('/docs/tags/assertion-tree/', 'ff4'),
            exact: true
          },
          {
            path: '/docs/tags/assertions/',
            component: ComponentCreator('/docs/tags/assertions/', '0c4'),
            exact: true
          },
          {
            path: '/docs/tags/auto-replay/',
            component: ComponentCreator('/docs/tags/auto-replay/', '019'),
            exact: true
          },
          {
            path: '/docs/tags/auto-test-generation/',
            component: ComponentCreator('/docs/tags/auto-test-generation/', '7c1'),
            exact: true
          },
          {
            path: '/docs/tags/automated-testing/',
            component: ComponentCreator('/docs/tags/automated-testing/', 'b47'),
            exact: true
          },
          {
            path: '/docs/tags/automation/',
            component: ComponentCreator('/docs/tags/automation/', '05e'),
            exact: true
          },
          {
            path: '/docs/tags/basics/',
            component: ComponentCreator('/docs/tags/basics/', '005'),
            exact: true
          },
          {
            path: '/docs/tags/bdd/',
            component: ComponentCreator('/docs/tags/bdd/', '900'),
            exact: true
          },
          {
            path: '/docs/tags/best-practices/',
            component: ComponentCreator('/docs/tags/best-practices/', '01f'),
            exact: true
          },
          {
            path: '/docs/tags/branch/',
            component: ComponentCreator('/docs/tags/branch/', 'd4d'),
            exact: true
          },
          {
            path: '/docs/tags/branches/',
            component: ComponentCreator('/docs/tags/branches/', '465'),
            exact: true
          },
          {
            path: '/docs/tags/breaking-changes/',
            component: ComponentCreator('/docs/tags/breaking-changes/', '7f3'),
            exact: true
          },
          {
            path: '/docs/tags/browser-extension/',
            component: ComponentCreator('/docs/tags/browser-extension/', 'e97'),
            exact: true
          },
          {
            path: '/docs/tags/browser-sdk/',
            component: ComponentCreator('/docs/tags/browser-sdk/', 'f91'),
            exact: true
          },
          {
            path: '/docs/tags/bulk-actions/',
            component: ComponentCreator('/docs/tags/bulk-actions/', '2d2'),
            exact: true
          },
          {
            path: '/docs/tags/bulk-assertions/',
            component: ComponentCreator('/docs/tags/bulk-assertions/', 'aab'),
            exact: true
          },
          {
            path: '/docs/tags/bulk-operations/',
            component: ComponentCreator('/docs/tags/bulk-operations/', '524'),
            exact: true
          },
          {
            path: '/docs/tags/bun-js-framework/',
            component: ComponentCreator('/docs/tags/bun-js-framework/', '424'),
            exact: true
          },
          {
            path: '/docs/tags/cd/',
            component: ComponentCreator('/docs/tags/cd/', '9a4'),
            exact: true
          },
          {
            path: '/docs/tags/change-management/',
            component: ComponentCreator('/docs/tags/change-management/', '4cf'),
            exact: true
          },
          {
            path: '/docs/tags/ci-cd/',
            component: ComponentCreator('/docs/tags/ci-cd/', '83b'),
            exact: true
          },
          {
            path: '/docs/tags/ci-guide/',
            component: ComponentCreator('/docs/tags/ci-guide/', 'abc'),
            exact: true
          },
          {
            path: '/docs/tags/ci-pipeline/',
            component: ComponentCreator('/docs/tags/ci-pipeline/', '7cd'),
            exact: true
          },
          {
            path: '/docs/tags/ci-testing/',
            component: ComponentCreator('/docs/tags/ci-testing/', '300'),
            exact: true
          },
          {
            path: '/docs/tags/ci/',
            component: ComponentCreator('/docs/tags/ci/', 'b6a'),
            exact: true
          },
          {
            path: '/docs/tags/claude-code/',
            component: ComponentCreator('/docs/tags/claude-code/', 'fa1'),
            exact: true
          },
          {
            path: '/docs/tags/cli-commands/',
            component: ComponentCreator('/docs/tags/cli-commands/', '222'),
            exact: true
          },
          {
            path: '/docs/tags/cli/',
            component: ComponentCreator('/docs/tags/cli/', '6de'),
            exact: true
          },
          {
            path: '/docs/tags/cloud-replay/',
            component: ComponentCreator('/docs/tags/cloud-replay/', '9a1'),
            exact: true
          },
          {
            path: '/docs/tags/code-coverage/',
            component: ComponentCreator('/docs/tags/code-coverage/', '8ad'),
            exact: true
          },
          {
            path: '/docs/tags/code-privacy/',
            component: ComponentCreator('/docs/tags/code-privacy/', '8e8'),
            exact: true
          },
          {
            path: '/docs/tags/collaboration/',
            component: ComponentCreator('/docs/tags/collaboration/', '817'),
            exact: true
          },
          {
            path: '/docs/tags/communication/',
            component: ComponentCreator('/docs/tags/communication/', '98b'),
            exact: true
          },
          {
            path: '/docs/tags/compliance/',
            component: ComponentCreator('/docs/tags/compliance/', 'aaa'),
            exact: true
          },
          {
            path: '/docs/tags/component-testing/',
            component: ComponentCreator('/docs/tags/component-testing/', '51e'),
            exact: true
          },
          {
            path: '/docs/tags/configuration-file/',
            component: ComponentCreator('/docs/tags/configuration-file/', '07b'),
            exact: true
          },
          {
            path: '/docs/tags/contact/',
            component: ComponentCreator('/docs/tags/contact/', '787'),
            exact: true
          },
          {
            path: '/docs/tags/contour/',
            component: ComponentCreator('/docs/tags/contour/', '949'),
            exact: true
          },
          {
            path: '/docs/tags/contributing/',
            component: ComponentCreator('/docs/tags/contributing/', '21f'),
            exact: true
          },
          {
            path: '/docs/tags/contribution-guide/',
            component: ComponentCreator('/docs/tags/contribution-guide/', '6a1'),
            exact: true
          },
          {
            path: '/docs/tags/coverage/',
            component: ComponentCreator('/docs/tags/coverage/', 'c8e'),
            exact: true
          },
          {
            path: '/docs/tags/csharp/',
            component: ComponentCreator('/docs/tags/csharp/', 'fb1'),
            exact: true
          },
          {
            path: '/docs/tags/curl/',
            component: ComponentCreator('/docs/tags/curl/', '35a'),
            exact: true
          },
          {
            path: '/docs/tags/cursor/',
            component: ComponentCreator('/docs/tags/cursor/', '03c'),
            exact: true
          },
          {
            path: '/docs/tags/custom-functions/',
            component: ComponentCreator('/docs/tags/custom-functions/', '99a'),
            exact: true
          },
          {
            path: '/docs/tags/custom-mocks/',
            component: ComponentCreator('/docs/tags/custom-mocks/', 'ed6'),
            exact: true
          },
          {
            path: '/docs/tags/custom-validation/',
            component: ComponentCreator('/docs/tags/custom-validation/', '7c7'),
            exact: true
          },
          {
            path: '/docs/tags/custom-variables/',
            component: ComponentCreator('/docs/tags/custom-variables/', '05e'),
            exact: true
          },
          {
            path: '/docs/tags/daemonset/',
            component: ComponentCreator('/docs/tags/daemonset/', '279'),
            exact: true
          },
          {
            path: '/docs/tags/debugger-guide/',
            component: ComponentCreator('/docs/tags/debugger-guide/', '900'),
            exact: true
          },
          {
            path: '/docs/tags/debugging/',
            component: ComponentCreator('/docs/tags/debugging/', '1f2'),
            exact: true
          },
          {
            path: '/docs/tags/deduplication/',
            component: ComponentCreator('/docs/tags/deduplication/', '720'),
            exact: true
          },
          {
            path: '/docs/tags/defect-management/',
            component: ComponentCreator('/docs/tags/defect-management/', '7ee'),
            exact: true
          },
          {
            path: '/docs/tags/dev-guide/',
            component: ComponentCreator('/docs/tags/dev-guide/', '0fa'),
            exact: true
          },
          {
            path: '/docs/tags/developer-workflow/',
            component: ComponentCreator('/docs/tags/developer-workflow/', '3a9'),
            exact: true
          },
          {
            path: '/docs/tags/devs/',
            component: ComponentCreator('/docs/tags/devs/', '9f3'),
            exact: true
          },
          {
            path: '/docs/tags/docker-tls/',
            component: ComponentCreator('/docs/tags/docker-tls/', 'c2d'),
            exact: true
          },
          {
            path: '/docs/tags/docker/',
            component: ComponentCreator('/docs/tags/docker/', 'fe9'),
            exact: true
          },
          {
            path: '/docs/tags/dotnet-framework/',
            component: ComponentCreator('/docs/tags/dotnet-framework/', '515'),
            exact: true
          },
          {
            path: '/docs/tags/ebpf/',
            component: ComponentCreator('/docs/tags/ebpf/', 'dfb'),
            exact: true
          },
          {
            path: '/docs/tags/edge-cases/',
            component: ComponentCreator('/docs/tags/edge-cases/', 'bb1'),
            exact: true
          },
          {
            path: '/docs/tags/edit-assertions/',
            component: ComponentCreator('/docs/tags/edit-assertions/', 'a7c'),
            exact: true
          },
          {
            path: '/docs/tags/examples/',
            component: ComponentCreator('/docs/tags/examples/', '0a1'),
            exact: true
          },
          {
            path: '/docs/tags/explanation/',
            component: ComponentCreator('/docs/tags/explanation/', 'eb7'),
            exact: true
          },
          {
            path: '/docs/tags/expressjs/',
            component: ComponentCreator('/docs/tags/expressjs/', '7db'),
            exact: true
          },
          {
            path: '/docs/tags/faq/',
            component: ComponentCreator('/docs/tags/faq/', '521'),
            exact: true
          },
          {
            path: '/docs/tags/fast-api-framework/',
            component: ComponentCreator('/docs/tags/fast-api-framework/', '059'),
            exact: true
          },
          {
            path: '/docs/tags/fasthttp/',
            component: ComponentCreator('/docs/tags/fasthttp/', 'fb3'),
            exact: true
          },
          {
            path: '/docs/tags/feature-guide/',
            component: ComponentCreator('/docs/tags/feature-guide/', '0db'),
            exact: true
          },
          {
            path: '/docs/tags/features/',
            component: ComponentCreator('/docs/tags/features/', 'ce3'),
            exact: true
          },
          {
            path: '/docs/tags/filter-suites/',
            component: ComponentCreator('/docs/tags/filter-suites/', '697'),
            exact: true
          },
          {
            path: '/docs/tags/flags/',
            component: ComponentCreator('/docs/tags/flags/', '3cf'),
            exact: true
          },
          {
            path: '/docs/tags/flaky-test-repair/',
            component: ComponentCreator('/docs/tags/flaky-test-repair/', '9af'),
            exact: true
          },
          {
            path: '/docs/tags/flask-framework/',
            component: ComponentCreator('/docs/tags/flask-framework/', '926'),
            exact: true
          },
          {
            path: '/docs/tags/flask/',
            component: ComponentCreator('/docs/tags/flask/', '98f'),
            exact: true
          },
          {
            path: '/docs/tags/flux/',
            component: ComponentCreator('/docs/tags/flux/', '9a5'),
            exact: true
          },
          {
            path: '/docs/tags/functional-testing/',
            component: ComponentCreator('/docs/tags/functional-testing/', '965'),
            exact: true
          },
          {
            path: '/docs/tags/gemini/',
            component: ComponentCreator('/docs/tags/gemini/', '229'),
            exact: true
          },
          {
            path: '/docs/tags/generate-test-cases/',
            component: ComponentCreator('/docs/tags/generate-test-cases/', '816'),
            exact: true
          },
          {
            path: '/docs/tags/generate-unit-test/',
            component: ComponentCreator('/docs/tags/generate-unit-test/', '7da'),
            exact: true
          },
          {
            path: '/docs/tags/generation-history/',
            component: ComponentCreator('/docs/tags/generation-history/', 'f68'),
            exact: true
          },
          {
            path: '/docs/tags/gin-framework/',
            component: ComponentCreator('/docs/tags/gin-framework/', '20c'),
            exact: true
          },
          {
            path: '/docs/tags/github/',
            component: ComponentCreator('/docs/tags/github/', '610'),
            exact: true
          },
          {
            path: '/docs/tags/gitops/',
            component: ComponentCreator('/docs/tags/gitops/', '415'),
            exact: true
          },
          {
            path: '/docs/tags/glossary/',
            component: ComponentCreator('/docs/tags/glossary/', '30e'),
            exact: true
          },
          {
            path: '/docs/tags/go-test/',
            component: ComponentCreator('/docs/tags/go-test/', '9c8'),
            exact: true
          },
          {
            path: '/docs/tags/go/',
            component: ComponentCreator('/docs/tags/go/', '445'),
            exact: true
          },
          {
            path: '/docs/tags/gpt-4/',
            component: ComponentCreator('/docs/tags/gpt-4/', 'a66'),
            exact: true
          },
          {
            path: '/docs/tags/graph-ql/',
            component: ComponentCreator('/docs/tags/graph-ql/', 'd24'),
            exact: true
          },
          {
            path: '/docs/tags/guide/',
            component: ComponentCreator('/docs/tags/guide/', '77c'),
            exact: true
          },
          {
            path: '/docs/tags/hello-world/',
            component: ComponentCreator('/docs/tags/hello-world/', '9c6'),
            exact: true
          },
          {
            path: '/docs/tags/install/',
            component: ComponentCreator('/docs/tags/install/', '0c1'),
            exact: true
          },
          {
            path: '/docs/tags/installation-guide/',
            component: ComponentCreator('/docs/tags/installation-guide/', '981'),
            exact: true
          },
          {
            path: '/docs/tags/installation/',
            component: ComponentCreator('/docs/tags/installation/', '85e'),
            exact: true
          },
          {
            path: '/docs/tags/integration/',
            component: ComponentCreator('/docs/tags/integration/', '07b'),
            exact: true
          },
          {
            path: '/docs/tags/integrations/',
            component: ComponentCreator('/docs/tags/integrations/', 'bdd'),
            exact: true
          },
          {
            path: '/docs/tags/introduction/',
            component: ComponentCreator('/docs/tags/introduction/', '74a'),
            exact: true
          },
          {
            path: '/docs/tags/java-framework/',
            component: ComponentCreator('/docs/tags/java-framework/', 'bea'),
            exact: true
          },
          {
            path: '/docs/tags/java/',
            component: ComponentCreator('/docs/tags/java/', 'a6b'),
            exact: true
          },
          {
            path: '/docs/tags/javascript/',
            component: ComponentCreator('/docs/tags/javascript/', 'f8f'),
            exact: true
          },
          {
            path: '/docs/tags/jest/',
            component: ComponentCreator('/docs/tags/jest/', '0eb'),
            exact: true
          },
          {
            path: '/docs/tags/job-tracking/',
            component: ComponentCreator('/docs/tags/job-tracking/', '6c6'),
            exact: true
          },
          {
            path: '/docs/tags/js/',
            component: ComponentCreator('/docs/tags/js/', '00d'),
            exact: true
          },
          {
            path: '/docs/tags/jwt/',
            component: ComponentCreator('/docs/tags/jwt/', 'f97'),
            exact: true
          },
          {
            path: '/docs/tags/k-8-s-proxy/',
            component: ComponentCreator('/docs/tags/k-8-s-proxy/', '5e0'),
            exact: true
          },
          {
            path: '/docs/tags/k-8-s/',
            component: ComponentCreator('/docs/tags/k-8-s/', 'eca'),
            exact: true
          },
          {
            path: '/docs/tags/keploy-cloud/',
            component: ComponentCreator('/docs/tags/keploy-cloud/', '3e1'),
            exact: true
          },
          {
            path: '/docs/tags/keploy-console/',
            component: ComponentCreator('/docs/tags/keploy-console/', '4f5'),
            exact: true
          },
          {
            path: '/docs/tags/keploy-features/',
            component: ComponentCreator('/docs/tags/keploy-features/', '7bf'),
            exact: true
          },
          {
            path: '/docs/tags/keploy-karaf/',
            component: ComponentCreator('/docs/tags/keploy-karaf/', 'f61'),
            exact: true
          },
          {
            path: '/docs/tags/keploy-passthrough/',
            component: ComponentCreator('/docs/tags/keploy-passthrough/', '365'),
            exact: true
          },
          {
            path: '/docs/tags/keploy-templatize/',
            component: ComponentCreator('/docs/tags/keploy-templatize/', 'c13'),
            exact: true
          },
          {
            path: '/docs/tags/keploy/',
            component: ComponentCreator('/docs/tags/keploy/', '952'),
            exact: true
          },
          {
            path: '/docs/tags/kind/',
            component: ComponentCreator('/docs/tags/kind/', 'd98'),
            exact: true
          },
          {
            path: '/docs/tags/kubernetes/',
            component: ComponentCreator('/docs/tags/kubernetes/', 'aa9'),
            exact: true
          },
          {
            path: '/docs/tags/labels/',
            component: ComponentCreator('/docs/tags/labels/', '724'),
            exact: true
          },
          {
            path: '/docs/tags/limitations/',
            component: ComponentCreator('/docs/tags/limitations/', '474'),
            exact: true
          },
          {
            path: '/docs/tags/linux/',
            component: ComponentCreator('/docs/tags/linux/', '919'),
            exact: true
          },
          {
            path: '/docs/tags/live-recording/',
            component: ComponentCreator('/docs/tags/live-recording/', '7d7'),
            exact: true
          },
          {
            path: '/docs/tags/llm/',
            component: ComponentCreator('/docs/tags/llm/', '4f6'),
            exact: true
          },
          {
            path: '/docs/tags/local-agent/',
            component: ComponentCreator('/docs/tags/local-agent/', '6bc'),
            exact: true
          },
          {
            path: '/docs/tags/macos/',
            component: ComponentCreator('/docs/tags/macos/', '879'),
            exact: true
          },
          {
            path: '/docs/tags/manual-testing/',
            component: ComponentCreator('/docs/tags/manual-testing/', 'b87'),
            exact: true
          },
          {
            path: '/docs/tags/mcp/',
            component: ComponentCreator('/docs/tags/mcp/', '83a'),
            exact: true
          },
          {
            path: '/docs/tags/microservices/',
            component: ComponentCreator('/docs/tags/microservices/', 'eb8'),
            exact: true
          },
          {
            path: '/docs/tags/mock-mutations/',
            component: ComponentCreator('/docs/tags/mock-mutations/', 'f30'),
            exact: true
          },
          {
            path: '/docs/tags/mock-storage/',
            component: ComponentCreator('/docs/tags/mock-storage/', '9ed'),
            exact: true
          },
          {
            path: '/docs/tags/mock-with-test/',
            component: ComponentCreator('/docs/tags/mock-with-test/', '832'),
            exact: true
          },
          {
            path: '/docs/tags/mocking/',
            component: ComponentCreator('/docs/tags/mocking/', '4fd'),
            exact: true
          },
          {
            path: '/docs/tags/mocks/',
            component: ComponentCreator('/docs/tags/mocks/', 'b9c'),
            exact: true
          },
          {
            path: '/docs/tags/mongo-db/',
            component: ComponentCreator('/docs/tags/mongo-db/', 'e15'),
            exact: true
          },
          {
            path: '/docs/tags/mongo/',
            component: ComponentCreator('/docs/tags/mongo/', '61c'),
            exact: true
          },
          {
            path: '/docs/tags/mongodb/',
            component: ComponentCreator('/docs/tags/mongodb/', '5e8'),
            exact: true
          },
          {
            path: '/docs/tags/mux-framework/',
            component: ComponentCreator('/docs/tags/mux-framework/', 'afd'),
            exact: true
          },
          {
            path: '/docs/tags/mysql/',
            component: ComponentCreator('/docs/tags/mysql/', '011'),
            exact: true
          },
          {
            path: '/docs/tags/new-application/',
            component: ComponentCreator('/docs/tags/new-application/', '835'),
            exact: true
          },
          {
            path: '/docs/tags/next-js/',
            component: ComponentCreator('/docs/tags/next-js/', '16e'),
            exact: true
          },
          {
            path: '/docs/tags/nhost/',
            component: ComponentCreator('/docs/tags/nhost/', '294'),
            exact: true
          },
          {
            path: '/docs/tags/node/',
            component: ComponentCreator('/docs/tags/node/', '9d2'),
            exact: true
          },
          {
            path: '/docs/tags/nodejs/',
            component: ComponentCreator('/docs/tags/nodejs/', '3f1'),
            exact: true
          },
          {
            path: '/docs/tags/npm/',
            component: ComponentCreator('/docs/tags/npm/', '24f'),
            exact: true
          },
          {
            path: '/docs/tags/observability/',
            component: ComponentCreator('/docs/tags/observability/', '70b'),
            exact: true
          },
          {
            path: '/docs/tags/open-ai/',
            component: ComponentCreator('/docs/tags/open-ai/', 'f57'),
            exact: true
          },
          {
            path: '/docs/tags/open-api/',
            component: ComponentCreator('/docs/tags/open-api/', '904'),
            exact: true
          },
          {
            path: '/docs/tags/openhospital/',
            component: ComponentCreator('/docs/tags/openhospital/', '129'),
            exact: true
          },
          {
            path: '/docs/tags/operation-guide/',
            component: ComponentCreator('/docs/tags/operation-guide/', '07e'),
            exact: true
          },
          {
            path: '/docs/tags/performance-testing/',
            component: ComponentCreator('/docs/tags/performance-testing/', '2ad'),
            exact: true
          },
          {
            path: '/docs/tags/petclinic/',
            component: ComponentCreator('/docs/tags/petclinic/', '710'),
            exact: true
          },
          {
            path: '/docs/tags/plugin/',
            component: ComponentCreator('/docs/tags/plugin/', '246'),
            exact: true
          },
          {
            path: '/docs/tags/policy-enforcement/',
            component: ComponentCreator('/docs/tags/policy-enforcement/', '77e'),
            exact: true
          },
          {
            path: '/docs/tags/postgres/',
            component: ComponentCreator('/docs/tags/postgres/', '875'),
            exact: true
          },
          {
            path: '/docs/tags/postgrs/',
            component: ComponentCreator('/docs/tags/postgrs/', '6f8'),
            exact: true
          },
          {
            path: '/docs/tags/pr-agent/',
            component: ComponentCreator('/docs/tags/pr-agent/', 'fca'),
            exact: true
          },
          {
            path: '/docs/tags/privacy/',
            component: ComponentCreator('/docs/tags/privacy/', 'ded'),
            exact: true
          },
          {
            path: '/docs/tags/programmatic-access/',
            component: ComponentCreator('/docs/tags/programmatic-access/', 'c9c'),
            exact: true
          },
          {
            path: '/docs/tags/pytest/',
            component: ComponentCreator('/docs/tags/pytest/', '2c3'),
            exact: true
          },
          {
            path: '/docs/tags/python-framework/',
            component: ComponentCreator('/docs/tags/python-framework/', '532'),
            exact: true
          },
          {
            path: '/docs/tags/python/',
            component: ComponentCreator('/docs/tags/python/', '629'),
            exact: true
          },
          {
            path: '/docs/tags/qa-automation/',
            component: ComponentCreator('/docs/tags/qa-automation/', 'd53'),
            exact: true
          },
          {
            path: '/docs/tags/qa-tools/',
            component: ComponentCreator('/docs/tags/qa-tools/', '652'),
            exact: true
          },
          {
            path: '/docs/tags/qa/',
            component: ComponentCreator('/docs/tags/qa/', 'c3a'),
            exact: true
          },
          {
            path: '/docs/tags/quickstart/',
            component: ComponentCreator('/docs/tags/quickstart/', '74e'),
            exact: true
          },
          {
            path: '/docs/tags/react/',
            component: ComponentCreator('/docs/tags/react/', '28c'),
            exact: true
          },
          {
            path: '/docs/tags/record-and-replay-api-tests/',
            component: ComponentCreator('/docs/tags/record-and-replay-api-tests/', 'bc0'),
            exact: true
          },
          {
            path: '/docs/tags/record-and-replay/',
            component: ComponentCreator('/docs/tags/record-and-replay/', 'a8f'),
            exact: true
          },
          {
            path: '/docs/tags/record-guide/',
            component: ComponentCreator('/docs/tags/record-guide/', '99e'),
            exact: true
          },
          {
            path: '/docs/tags/record-replay-test/',
            component: ComponentCreator('/docs/tags/record-replay-test/', '167'),
            exact: true
          },
          {
            path: '/docs/tags/record-test-case/',
            component: ComponentCreator('/docs/tags/record-test-case/', '93f'),
            exact: true
          },
          {
            path: '/docs/tags/record/',
            component: ComponentCreator('/docs/tags/record/', 'a04'),
            exact: true
          },
          {
            path: '/docs/tags/recording-filters/',
            component: ComponentCreator('/docs/tags/recording-filters/', '902'),
            exact: true
          },
          {
            path: '/docs/tags/recording/',
            component: ComponentCreator('/docs/tags/recording/', '2e9'),
            exact: true
          },
          {
            path: '/docs/tags/redis/',
            component: ComponentCreator('/docs/tags/redis/', '44e'),
            exact: true
          },
          {
            path: '/docs/tags/reference/',
            component: ComponentCreator('/docs/tags/reference/', 'ce6'),
            exact: true
          },
          {
            path: '/docs/tags/references/',
            component: ComponentCreator('/docs/tags/references/', 'f77'),
            exact: true
          },
          {
            path: '/docs/tags/reliability/',
            component: ComponentCreator('/docs/tags/reliability/', '6fb'),
            exact: true
          },
          {
            path: '/docs/tags/rename-testcases/',
            component: ComponentCreator('/docs/tags/rename-testcases/', '60f'),
            exact: true
          },
          {
            path: '/docs/tags/rename-testsets/',
            component: ComponentCreator('/docs/tags/rename-testsets/', '55c'),
            exact: true
          },
          {
            path: '/docs/tags/replay-guide/',
            component: ComponentCreator('/docs/tags/replay-guide/', 'b3e'),
            exact: true
          },
          {
            path: '/docs/tags/replay-test-case/',
            component: ComponentCreator('/docs/tags/replay-test-case/', '06d'),
            exact: true
          },
          {
            path: '/docs/tags/replay-tests/',
            component: ComponentCreator('/docs/tags/replay-tests/', 'e99'),
            exact: true
          },
          {
            path: '/docs/tags/reports/',
            component: ComponentCreator('/docs/tags/reports/', 'd20'),
            exact: true
          },
          {
            path: '/docs/tags/rest-api/',
            component: ComponentCreator('/docs/tags/rest-api/', '61c'),
            exact: true
          },
          {
            path: '/docs/tags/restful-api/',
            component: ComponentCreator('/docs/tags/restful-api/', 'ec0'),
            exact: true
          },
          {
            path: '/docs/tags/risk-analysis/',
            component: ComponentCreator('/docs/tags/risk-analysis/', 'bc1'),
            exact: true
          },
          {
            path: '/docs/tags/run-reports/',
            component: ComponentCreator('/docs/tags/run-reports/', '3da'),
            exact: true
          },
          {
            path: '/docs/tags/running-guide/',
            component: ComponentCreator('/docs/tags/running-guide/', 'e34'),
            exact: true
          },
          {
            path: '/docs/tags/rust/',
            component: ComponentCreator('/docs/tags/rust/', '0ad'),
            exact: true
          },
          {
            path: '/docs/tags/samples/',
            component: ComponentCreator('/docs/tags/samples/', '18e'),
            exact: true
          },
          {
            path: '/docs/tags/sanic/',
            component: ComponentCreator('/docs/tags/sanic/', 'ccf'),
            exact: true
          },
          {
            path: '/docs/tags/scalability/',
            component: ComponentCreator('/docs/tags/scalability/', 'de6'),
            exact: true
          },
          {
            path: '/docs/tags/schema-assertions/',
            component: ComponentCreator('/docs/tags/schema-assertions/', '218'),
            exact: true
          },
          {
            path: '/docs/tags/schema-coverage/',
            component: ComponentCreator('/docs/tags/schema-coverage/', '435'),
            exact: true
          },
          {
            path: '/docs/tags/schema-validation/',
            component: ComponentCreator('/docs/tags/schema-validation/', '210'),
            exact: true
          },
          {
            path: '/docs/tags/schema/',
            component: ComponentCreator('/docs/tags/schema/', '8dc'),
            exact: true
          },
          {
            path: '/docs/tags/security/',
            component: ComponentCreator('/docs/tags/security/', 'af3'),
            exact: true
          },
          {
            path: '/docs/tags/self-healing/',
            component: ComponentCreator('/docs/tags/self-healing/', '128'),
            exact: true
          },
          {
            path: '/docs/tags/self-hosted/',
            component: ComponentCreator('/docs/tags/self-hosted/', '8d9'),
            exact: true
          },
          {
            path: '/docs/tags/self-written-mocks/',
            component: ComponentCreator('/docs/tags/self-written-mocks/', 'a52'),
            exact: true
          },
          {
            path: '/docs/tags/server-setup/',
            component: ComponentCreator('/docs/tags/server-setup/', 'dd4'),
            exact: true
          },
          {
            path: '/docs/tags/smart-test-set/',
            component: ComponentCreator('/docs/tags/smart-test-set/', '088'),
            exact: true
          },
          {
            path: '/docs/tags/sms/',
            component: ComponentCreator('/docs/tags/sms/', '353'),
            exact: true
          },
          {
            path: '/docs/tags/software-quality/',
            component: ComponentCreator('/docs/tags/software-quality/', 'a6e'),
            exact: true
          },
          {
            path: '/docs/tags/software-testing/',
            component: ComponentCreator('/docs/tags/software-testing/', '859'),
            exact: true
          },
          {
            path: '/docs/tags/spring-boot/',
            component: ComponentCreator('/docs/tags/spring-boot/', '8e4'),
            exact: true
          },
          {
            path: '/docs/tags/spring-jpa/',
            component: ComponentCreator('/docs/tags/spring-jpa/', 'f95'),
            exact: true
          },
          {
            path: '/docs/tags/springboot/',
            component: ComponentCreator('/docs/tags/springboot/', 'a0f'),
            exact: true
          },
          {
            path: '/docs/tags/sql/',
            component: ComponentCreator('/docs/tags/sql/', 'b2e'),
            exact: true
          },
          {
            path: '/docs/tags/sse/',
            component: ComponentCreator('/docs/tags/sse/', '896'),
            exact: true
          },
          {
            path: '/docs/tags/suite-settings/',
            component: ComponentCreator('/docs/tags/suite-settings/', '9c9'),
            exact: true
          },
          {
            path: '/docs/tags/suite-status/',
            component: ComponentCreator('/docs/tags/suite-status/', 'd85'),
            exact: true
          },
          {
            path: '/docs/tags/support/',
            component: ComponentCreator('/docs/tags/support/', '362'),
            exact: true
          },
          {
            path: '/docs/tags/supported-languages/',
            component: ComponentCreator('/docs/tags/supported-languages/', '199'),
            exact: true
          },
          {
            path: '/docs/tags/svelte/',
            component: ComponentCreator('/docs/tags/svelte/', '4d7'),
            exact: true
          },
          {
            path: '/docs/tags/test-automation/',
            component: ComponentCreator('/docs/tags/test-automation/', '554'),
            exact: true
          },
          {
            path: '/docs/tags/test-deduplication/',
            component: ComponentCreator('/docs/tags/test-deduplication/', '34f'),
            exact: true
          },
          {
            path: '/docs/tags/test-execution/',
            component: ComponentCreator('/docs/tags/test-execution/', 'f6d'),
            exact: true
          },
          {
            path: '/docs/tags/test-failures/',
            component: ComponentCreator('/docs/tags/test-failures/', '52d'),
            exact: true
          },
          {
            path: '/docs/tags/test-flow/',
            component: ComponentCreator('/docs/tags/test-flow/', 'a39'),
            exact: true
          },
          {
            path: '/docs/tags/test-generation/',
            component: ComponentCreator('/docs/tags/test-generation/', '61f'),
            exact: true
          },
          {
            path: '/docs/tags/test-maintenance/',
            component: ComponentCreator('/docs/tags/test-maintenance/', '470'),
            exact: true
          },
          {
            path: '/docs/tags/test-management/',
            component: ComponentCreator('/docs/tags/test-management/', 'bac'),
            exact: true
          },
          {
            path: '/docs/tags/test-normalization/',
            component: ComponentCreator('/docs/tags/test-normalization/', 'eec'),
            exact: true
          },
          {
            path: '/docs/tags/test-organization/',
            component: ComponentCreator('/docs/tags/test-organization/', '854'),
            exact: true
          },
          {
            path: '/docs/tags/test-results/',
            component: ComponentCreator('/docs/tags/test-results/', 'ccc'),
            exact: true
          },
          {
            path: '/docs/tags/test-scripts/',
            component: ComponentCreator('/docs/tags/test-scripts/', '80f'),
            exact: true
          },
          {
            path: '/docs/tags/test-suite-management/',
            component: ComponentCreator('/docs/tags/test-suite-management/', '3fa'),
            exact: true
          },
          {
            path: '/docs/tags/test-suite/',
            component: ComponentCreator('/docs/tags/test-suite/', 'a43'),
            exact: true
          },
          {
            path: '/docs/tags/test-validation/',
            component: ComponentCreator('/docs/tags/test-validation/', 'fe5'),
            exact: true
          },
          {
            path: '/docs/tags/test-visualization/',
            component: ComponentCreator('/docs/tags/test-visualization/', 'd9a'),
            exact: true
          },
          {
            path: '/docs/tags/test/',
            component: ComponentCreator('/docs/tags/test/', 'd2b'),
            exact: true
          },
          {
            path: '/docs/tags/testing/',
            component: ComponentCreator('/docs/tags/testing/', '092'),
            exact: true
          },
          {
            path: '/docs/tags/time-sensitive-fields/',
            component: ComponentCreator('/docs/tags/time-sensitive-fields/', '8d6'),
            exact: true
          },
          {
            path: '/docs/tags/troubleshooting/',
            component: ComponentCreator('/docs/tags/troubleshooting/', 'd36'),
            exact: true
          },
          {
            path: '/docs/tags/tutorial/',
            component: ComponentCreator('/docs/tags/tutorial/', 'f72'),
            exact: true
          },
          {
            path: '/docs/tags/twilio/',
            component: ComponentCreator('/docs/tags/twilio/', 'b07'),
            exact: true
          },
          {
            path: '/docs/tags/typescript/',
            component: ComponentCreator('/docs/tags/typescript/', '246'),
            exact: true
          },
          {
            path: '/docs/tags/ui-capture/',
            component: ComponentCreator('/docs/tags/ui-capture/', '309'),
            exact: true
          },
          {
            path: '/docs/tags/ui-testing/',
            component: ComponentCreator('/docs/tags/ui-testing/', '8dc'),
            exact: true
          },
          {
            path: '/docs/tags/ui/',
            component: ComponentCreator('/docs/tags/ui/', 'eb7'),
            exact: true
          },
          {
            path: '/docs/tags/unit-test-generator-pr-agent/',
            component: ComponentCreator('/docs/tags/unit-test-generator-pr-agent/', 'c98'),
            exact: true
          },
          {
            path: '/docs/tags/unit-test-generator-pull-request-agent/',
            component: ComponentCreator('/docs/tags/unit-test-generator-pull-request-agent/', 'ff9'),
            exact: true
          },
          {
            path: '/docs/tags/unit-test-generator/',
            component: ComponentCreator('/docs/tags/unit-test-generator/', '57f'),
            exact: true
          },
          {
            path: '/docs/tags/unit-test/',
            component: ComponentCreator('/docs/tags/unit-test/', '97a'),
            exact: true
          },
          {
            path: '/docs/tags/unit-testing/',
            component: ComponentCreator('/docs/tags/unit-testing/', 'd39'),
            exact: true
          },
          {
            path: '/docs/tags/user-flows/',
            component: ComponentCreator('/docs/tags/user-flows/', 'aa8'),
            exact: true
          },
          {
            path: '/docs/tags/utg/',
            component: ComponentCreator('/docs/tags/utg/', 'f80'),
            exact: true
          },
          {
            path: '/docs/tags/validation/',
            component: ComponentCreator('/docs/tags/validation/', 'c3f'),
            exact: true
          },
          {
            path: '/docs/tags/visual-regression-testing/',
            component: ComponentCreator('/docs/tags/visual-regression-testing/', '507'),
            exact: true
          },
          {
            path: '/docs/tags/vs-code-extension/',
            component: ComponentCreator('/docs/tags/vs-code-extension/', '7ed'),
            exact: true
          },
          {
            path: '/docs/tags/vscode/',
            component: ComponentCreator('/docs/tags/vscode/', 'c18'),
            exact: true
          },
          {
            path: '/docs/tags/webhooks/',
            component: ComponentCreator('/docs/tags/webhooks/', '4fb'),
            exact: true
          },
          {
            path: '/docs/tags/what-is-keploy/',
            component: ComponentCreator('/docs/tags/what-is-keploy/', 'fe0'),
            exact: true
          },
          {
            path: '/docs/tags/why-keploy/',
            component: ComponentCreator('/docs/tags/why-keploy/', 'ef1'),
            exact: true
          },
          {
            path: '/docs/tags/windows-installation/',
            component: ComponentCreator('/docs/tags/windows-installation/', '4e6'),
            exact: true
          },
          {
            path: '/docs/tags/windows/',
            component: ComponentCreator('/docs/tags/windows/', '2f6'),
            exact: true
          },
          {
            path: '/docs/tags/workflow/',
            component: ComponentCreator('/docs/tags/workflow/', '93a'),
            exact: true
          },
          {
            path: '/docs/tags/workspace/',
            component: ComponentCreator('/docs/tags/workspace/', 'd54'),
            exact: true
          },
          {
            path: '/docs/tags/xml/',
            component: ComponentCreator('/docs/tags/xml/', '2dc'),
            exact: true
          },
          {
            path: '/docs/',
            component: ComponentCreator('/docs/', 'f85'),
            routes: [
              {
                path: '/docs/ci-cd/github/',
                component: ComponentCreator('/docs/ci-cd/github/', 'c93'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/ci-cd/gitlab/',
                component: ComponentCreator('/docs/ci-cd/gitlab/', '00f'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/ci-cd/jenkins/',
                component: ComponentCreator('/docs/ci-cd/jenkins/', '26a'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/concepts/',
                component: ComponentCreator('/docs/concepts/', '8c3'),
                exact: true
              },
              {
                path: '/docs/concepts/general-glossary/',
                component: ComponentCreator('/docs/concepts/general-glossary/', 'edc'),
                exact: true
              },
              {
                path: '/docs/concepts/installation/',
                component: ComponentCreator('/docs/concepts/installation/', '0db'),
                exact: true
              },
              {
                path: '/docs/concepts/platform-requirements/',
                component: ComponentCreator('/docs/concepts/platform-requirements/', '3ca'),
                exact: true
              },
              {
                path: '/docs/concepts/reference/glossary/acceptance-testing/',
                component: ComponentCreator('/docs/concepts/reference/glossary/acceptance-testing/', '560'),
                exact: true
              },
              {
                path: '/docs/concepts/reference/glossary/agile-unit-testing/',
                component: ComponentCreator('/docs/concepts/reference/glossary/agile-unit-testing/', '131'),
                exact: true
              },
              {
                path: '/docs/concepts/reference/glossary/ai-test-completion/',
                component: ComponentCreator('/docs/concepts/reference/glossary/ai-test-completion/', '965'),
                exact: true
              },
              {
                path: '/docs/concepts/reference/glossary/behaviour-driven-development/',
                component: ComponentCreator('/docs/concepts/reference/glossary/behaviour-driven-development/', 'b37'),
                exact: true
              },
              {
                path: '/docs/concepts/reference/glossary/beta-testing/',
                component: ComponentCreator('/docs/concepts/reference/glossary/beta-testing/', '6b2'),
                exact: true
              },
              {
                path: '/docs/concepts/reference/glossary/black-box-testing/',
                component: ComponentCreator('/docs/concepts/reference/glossary/black-box-testing/', '209'),
                exact: true
              },
              {
                path: '/docs/concepts/reference/glossary/code-coverage/',
                component: ComponentCreator('/docs/concepts/reference/glossary/code-coverage/', '406'),
                exact: true
              },
              {
                path: '/docs/concepts/reference/glossary/component-testing/',
                component: ComponentCreator('/docs/concepts/reference/glossary/component-testing/', '0d2'),
                exact: true
              },
              {
                path: '/docs/concepts/reference/glossary/cucumber-testing/',
                component: ComponentCreator('/docs/concepts/reference/glossary/cucumber-testing/', '853'),
                exact: true
              },
              {
                path: '/docs/concepts/reference/glossary/data-driven-testing/',
                component: ComponentCreator('/docs/concepts/reference/glossary/data-driven-testing/', '8af'),
                exact: true
              },
              {
                path: '/docs/concepts/reference/glossary/defect-management/',
                component: ComponentCreator('/docs/concepts/reference/glossary/defect-management/', 'e90'),
                exact: true
              },
              {
                path: '/docs/concepts/reference/glossary/end-to-end-testing/',
                component: ComponentCreator('/docs/concepts/reference/glossary/end-to-end-testing/', '836'),
                exact: true
              },
              {
                path: '/docs/concepts/reference/glossary/error-guessing/',
                component: ComponentCreator('/docs/concepts/reference/glossary/error-guessing/', 'c11'),
                exact: true
              },
              {
                path: '/docs/concepts/reference/glossary/functional-testing/',
                component: ComponentCreator('/docs/concepts/reference/glossary/functional-testing/', '1c9'),
                exact: true
              },
              {
                path: '/docs/concepts/reference/glossary/gray-box-testing/',
                component: ComponentCreator('/docs/concepts/reference/glossary/gray-box-testing/', 'e43'),
                exact: true
              },
              {
                path: '/docs/concepts/reference/glossary/grpc/',
                component: ComponentCreator('/docs/concepts/reference/glossary/grpc/', 'a90'),
                exact: true
              },
              {
                path: '/docs/concepts/reference/glossary/idempotency/',
                component: ComponentCreator('/docs/concepts/reference/glossary/idempotency/', '0fa'),
                exact: true
              },
              {
                path: '/docs/concepts/reference/glossary/integration-testing/',
                component: ComponentCreator('/docs/concepts/reference/glossary/integration-testing/', '975'),
                exact: true
              },
              {
                path: '/docs/concepts/reference/glossary/junit/',
                component: ComponentCreator('/docs/concepts/reference/glossary/junit/', 'a26'),
                exact: true
              },
              {
                path: '/docs/concepts/reference/glossary/load-testing/',
                component: ComponentCreator('/docs/concepts/reference/glossary/load-testing/', 'd24'),
                exact: true
              },
              {
                path: '/docs/concepts/reference/glossary/manual-testing/',
                component: ComponentCreator('/docs/concepts/reference/glossary/manual-testing/', '1f7'),
                exact: true
              },
              {
                path: '/docs/concepts/reference/glossary/microservice-testing/',
                component: ComponentCreator('/docs/concepts/reference/glossary/microservice-testing/', '7be'),
                exact: true
              },
              {
                path: '/docs/concepts/reference/glossary/mocks/',
                component: ComponentCreator('/docs/concepts/reference/glossary/mocks/', 'ace'),
                exact: true
              },
              {
                path: '/docs/concepts/reference/glossary/negative-testing/',
                component: ComponentCreator('/docs/concepts/reference/glossary/negative-testing/', 'db8'),
                exact: true
              },
              {
                path: '/docs/concepts/reference/glossary/observability-testing/',
                component: ComponentCreator('/docs/concepts/reference/glossary/observability-testing/', 'f24'),
                exact: true
              },
              {
                path: '/docs/concepts/reference/glossary/performance-testing/',
                component: ComponentCreator('/docs/concepts/reference/glossary/performance-testing/', '574'),
                exact: true
              },
              {
                path: '/docs/concepts/reference/glossary/qa-automation/',
                component: ComponentCreator('/docs/concepts/reference/glossary/qa-automation/', '7a5'),
                exact: true
              },
              {
                path: '/docs/concepts/reference/glossary/regression-testing/',
                component: ComponentCreator('/docs/concepts/reference/glossary/regression-testing/', '4b7'),
                exact: true
              },
              {
                path: '/docs/concepts/reference/glossary/reliability-testing/',
                component: ComponentCreator('/docs/concepts/reference/glossary/reliability-testing/', '6e7'),
                exact: true
              },
              {
                path: '/docs/concepts/reference/glossary/software-testing-life-cycle/',
                component: ComponentCreator('/docs/concepts/reference/glossary/software-testing-life-cycle/', 'e1a'),
                exact: true
              },
              {
                path: '/docs/concepts/reference/glossary/stubs/',
                component: ComponentCreator('/docs/concepts/reference/glossary/stubs/', '87c'),
                exact: true
              },
              {
                path: '/docs/concepts/reference/glossary/test-data-generation/',
                component: ComponentCreator('/docs/concepts/reference/glossary/test-data-generation/', 'cac'),
                exact: true
              },
              {
                path: '/docs/concepts/reference/glossary/test-driven-development/',
                component: ComponentCreator('/docs/concepts/reference/glossary/test-driven-development/', '908'),
                exact: true
              },
              {
                path: '/docs/concepts/reference/glossary/unit-test-automation/',
                component: ComponentCreator('/docs/concepts/reference/glossary/unit-test-automation/', 'bbc'),
                exact: true
              },
              {
                path: '/docs/concepts/reference/glossary/unit-testing/',
                component: ComponentCreator('/docs/concepts/reference/glossary/unit-testing/', '9e6'),
                exact: true
              },
              {
                path: '/docs/concepts/reference/glossary/visual-regression-testing/',
                component: ComponentCreator('/docs/concepts/reference/glossary/visual-regression-testing/', 'f57'),
                exact: true
              },
              {
                path: '/docs/concepts/reference/glossary/white-box-testing/',
                component: ComponentCreator('/docs/concepts/reference/glossary/white-box-testing/', 'bf3'),
                exact: true
              },
              {
                path: '/docs/concepts/support/',
                component: ComponentCreator('/docs/concepts/support/', '6b1'),
                exact: true
              },
              {
                path: '/docs/concepts/what-are-keploy-features/',
                component: ComponentCreator('/docs/concepts/what-are-keploy-features/', 'f2c'),
                exact: true
              },
              {
                path: '/docs/concepts/what-is-keploy-ebpf/',
                component: ComponentCreator('/docs/concepts/what-is-keploy-ebpf/', '133'),
                exact: true
              },
              {
                path: '/docs/concepts/what-is-keploy/',
                component: ComponentCreator('/docs/concepts/what-is-keploy/', '178'),
                exact: true
              },
              {
                path: '/docs/dependencies/',
                component: ComponentCreator('/docs/dependencies/', '651'),
                exact: true
              },
              {
                path: '/docs/dependencies/http/',
                component: ComponentCreator('/docs/dependencies/http/', '443'),
                exact: true
              },
              {
                path: '/docs/dependencies/mongo/',
                component: ComponentCreator('/docs/dependencies/mongo/', 'b9d'),
                exact: true
              },
              {
                path: '/docs/dependencies/postgres/',
                component: ComponentCreator('/docs/dependencies/postgres/', '9e3'),
                exact: true
              },
              {
                path: '/docs/dependencies/redis/',
                component: ComponentCreator('/docs/dependencies/redis/', 'fed'),
                exact: true
              },
              {
                path: '/docs/gsoc/contribution-guide/',
                component: ComponentCreator('/docs/gsoc/contribution-guide/', '8cc'),
                exact: true
              },
              {
                path: '/docs/hacktoberfest/code-contribution/',
                component: ComponentCreator('/docs/hacktoberfest/code-contribution/', 'fec'),
                exact: true
              },
              {
                path: '/docs/hacktoberfest/contribution-guide/',
                component: ComponentCreator('/docs/hacktoberfest/contribution-guide/', 'f77'),
                exact: true
              },
              {
                path: '/docs/hacktoberfest/no-code-contribution/',
                component: ComponentCreator('/docs/hacktoberfest/no-code-contribution/', 'a8e'),
                exact: true
              },
              {
                path: '/docs/installation/linux-installation/',
                component: ComponentCreator('/docs/installation/linux-installation/', '73a'),
                exact: true
              },
              {
                path: '/docs/installation/macos-installation/',
                component: ComponentCreator('/docs/installation/macos-installation/', '60e'),
                exact: true
              },
              {
                path: '/docs/installation/windows-installation/',
                component: ComponentCreator('/docs/installation/windows-installation/', '4dd'),
                exact: true
              },
              {
                path: '/docs/keploy-cloud/application-settings/',
                component: ComponentCreator('/docs/keploy-cloud/application-settings/', '9fb'),
                exact: true
              },
              {
                path: '/docs/keploy-cloud/auto-test-generation/',
                component: ComponentCreator('/docs/keploy-cloud/auto-test-generation/', 'e36'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/keploy-cloud/cloud-installation/',
                component: ComponentCreator('/docs/keploy-cloud/cloud-installation/', '0b3'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/keploy-cloud/cloud-replay/',
                component: ComponentCreator('/docs/keploy-cloud/cloud-replay/', '6c5'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/keploy-cloud/deduplication/',
                component: ComponentCreator('/docs/keploy-cloud/deduplication/', 'b60'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/keploy-cloud/gitops-argocd/',
                component: ComponentCreator('/docs/keploy-cloud/gitops-argocd/', '084'),
                exact: true
              },
              {
                path: '/docs/keploy-cloud/gitops-flux/',
                component: ComponentCreator('/docs/keploy-cloud/gitops-flux/', 'e5a'),
                exact: true
              },
              {
                path: '/docs/keploy-cloud/keploy-console/',
                component: ComponentCreator('/docs/keploy-cloud/keploy-console/', '3a3'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/keploy-cloud/kubernetes-local-setup/',
                component: ComponentCreator('/docs/keploy-cloud/kubernetes-local-setup/', '436'),
                exact: true
              },
              {
                path: '/docs/keploy-cloud/kubernetes/',
                component: ComponentCreator('/docs/keploy-cloud/kubernetes/', '02a'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/keploy-cloud/mock-registry/',
                component: ComponentCreator('/docs/keploy-cloud/mock-registry/', 'a23'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/keploy-cloud/smart-set-agent/',
                component: ComponentCreator('/docs/keploy-cloud/smart-set-agent/', '729'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/keploy-cloud/static-deduplication/',
                component: ComponentCreator('/docs/keploy-cloud/static-deduplication/', '13f'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/keploy-cloud/time-freezing/',
                component: ComponentCreator('/docs/keploy-cloud/time-freezing/', '174'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/keploy-explained/ai-models/',
                component: ComponentCreator('/docs/keploy-explained/ai-models/', '040'),
                exact: true
              },
              {
                path: '/docs/keploy-explained/api-testing-faq/',
                component: ComponentCreator('/docs/keploy-explained/api-testing-faq/', '788'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/keploy-explained/common-errors/',
                component: ComponentCreator('/docs/keploy-explained/common-errors/', 'fb9'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/keploy-explained/contribution-guide/',
                component: ComponentCreator('/docs/keploy-explained/contribution-guide/', 'b8c'),
                exact: true,
                sidebar: "sidebarContributionGuide"
              },
              {
                path: '/docs/keploy-explained/debugger-guide/',
                component: ComponentCreator('/docs/keploy-explained/debugger-guide/', '498'),
                exact: true
              },
              {
                path: '/docs/keploy-explained/docs-dev-guide/',
                component: ComponentCreator('/docs/keploy-explained/docs-dev-guide/', 'c4c'),
                exact: true,
                sidebar: "sidebarContributionGuide"
              },
              {
                path: '/docs/keploy-explained/how-keploy-works/',
                component: ComponentCreator('/docs/keploy-explained/how-keploy-works/', '814'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/keploy-explained/integration-testing-faq/',
                component: ComponentCreator('/docs/keploy-explained/integration-testing-faq/', '693'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/keploy-explained/integrations-pr-agent/',
                component: ComponentCreator('/docs/keploy-explained/integrations-pr-agent/', 'e30'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/keploy-explained/integrations-vscode/',
                component: ComponentCreator('/docs/keploy-explained/integrations-vscode/', '640'),
                exact: true
              },
              {
                path: '/docs/keploy-explained/introduction/',
                component: ComponentCreator('/docs/keploy-explained/introduction/', '323'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/keploy-explained/keploy-privacy/',
                component: ComponentCreator('/docs/keploy-explained/keploy-privacy/', 'ea5'),
                exact: true
              },
              {
                path: '/docs/keploy-explained/keploy-security/',
                component: ComponentCreator('/docs/keploy-explained/keploy-security/', 'e32'),
                exact: true
              },
              {
                path: '/docs/keploy-explained/mac-linux/',
                component: ComponentCreator('/docs/keploy-explained/mac-linux/', '768'),
                exact: true
              },
              {
                path: '/docs/keploy-explained/supported-languages/',
                component: ComponentCreator('/docs/keploy-explained/supported-languages/', 'a32'),
                exact: true
              },
              {
                path: '/docs/keploy-explained/testing-guide/',
                component: ComponentCreator('/docs/keploy-explained/testing-guide/', 'f3e'),
                exact: true
              },
              {
                path: '/docs/keploy-explained/unit-testing-faq/',
                component: ComponentCreator('/docs/keploy-explained/unit-testing-faq/', '9de'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/keploy-explained/utg-best-practices/',
                component: ComponentCreator('/docs/keploy-explained/utg-best-practices/', 'b4f'),
                exact: true
              },
              {
                path: '/docs/keploy-explained/why-keploy/',
                component: ComponentCreator('/docs/keploy-explained/why-keploy/', '69c'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/keploy-explained/windows-wsl/',
                component: ComponentCreator('/docs/keploy-explained/windows-wsl/', 'd55'),
                exact: true
              },
              {
                path: '/docs/operation/',
                component: ComponentCreator('/docs/operation/', 'f58'),
                exact: true
              },
              {
                path: '/docs/operation/browser-extension-operations/',
                component: ComponentCreator('/docs/operation/browser-extension-operations/', '3bd'),
                exact: true
              },
              {
                path: '/docs/operation/record-operations/',
                component: ComponentCreator('/docs/operation/record-operations/', 'ccb'),
                exact: true
              },
              {
                path: '/docs/operation/test-operations/',
                component: ComponentCreator('/docs/operation/test-operations/', 'ddc'),
                exact: true
              },
              {
                path: '/docs/operation/web-ui-operations/',
                component: ComponentCreator('/docs/operation/web-ui-operations/', '421'),
                exact: true
              },
              {
                path: '/docs/quickstart/code-coverage/',
                component: ComponentCreator('/docs/quickstart/code-coverage/', '31f'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/quickstart/crud-nodejs/',
                component: ComponentCreator('/docs/quickstart/crud-nodejs/', '2e6'),
                exact: true
              },
              {
                path: '/docs/quickstart/express-mongoose-application/',
                component: ComponentCreator('/docs/quickstart/express-mongoose-application/', '9c1'),
                exact: true
              },
              {
                path: '/docs/quickstart/express-postgresql-prisma/',
                component: ComponentCreator('/docs/quickstart/express-postgresql-prisma/', '1d0'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/quickstart/flask-redis/',
                component: ComponentCreator('/docs/quickstart/flask-redis/', '99b'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/quickstart/golang-filter/',
                component: ComponentCreator('/docs/quickstart/golang-filter/', '303'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/quickstart/java-spring-boot-mongo/',
                component: ComponentCreator('/docs/quickstart/java-spring-boot-mongo/', '526'),
                exact: true
              },
              {
                path: '/docs/quickstart/java-spring-boot-xml/',
                component: ComponentCreator('/docs/quickstart/java-spring-boot-xml/', '048'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/quickstart/java-springboot-filter/',
                component: ComponentCreator('/docs/quickstart/java-springboot-filter/', 'e30'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/quickstart/javascript-filter/',
                component: ComponentCreator('/docs/quickstart/javascript-filter/', 'd9f'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/quickstart/k8s-proxy-developer-workflow/',
                component: ComponentCreator('/docs/quickstart/k8s-proxy-developer-workflow/', '008'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/quickstart/k8s-proxy-llm-workflow/',
                component: ComponentCreator('/docs/quickstart/k8s-proxy-llm-workflow/', '336'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/quickstart/k8s-proxy/',
                component: ComponentCreator('/docs/quickstart/k8s-proxy/', '957'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/quickstart/openhospital/',
                component: ComponentCreator('/docs/quickstart/openhospital/', '217'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/quickstart/pet-clinic/',
                component: ComponentCreator('/docs/quickstart/pet-clinic/', '78b'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/quickstart/python-filter/',
                component: ComponentCreator('/docs/quickstart/python-filter/', '45c'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/quickstart/quickstart-filter/',
                component: ComponentCreator('/docs/quickstart/quickstart-filter/', '33c'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/quickstart/rust-filter/',
                component: ComponentCreator('/docs/quickstart/rust-filter/', '21c'),
                exact: true
              },
              {
                path: '/docs/quickstart/sample-rust-crud-mongo/',
                component: ComponentCreator('/docs/quickstart/sample-rust-crud-mongo/', 'bc6'),
                exact: true
              },
              {
                path: '/docs/quickstart/samples-bunjs/',
                component: ComponentCreator('/docs/quickstart/samples-bunjs/', '9d6'),
                exact: true
              },
              {
                path: '/docs/quickstart/samples-csharp/',
                component: ComponentCreator('/docs/quickstart/samples-csharp/', 'e56'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/quickstart/samples-django/',
                component: ComponentCreator('/docs/quickstart/samples-django/', '253'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/quickstart/samples-echo/',
                component: ComponentCreator('/docs/quickstart/samples-echo/', 'cb2'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/quickstart/samples-fastapi-twilio/',
                component: ComponentCreator('/docs/quickstart/samples-fastapi-twilio/', 'aff'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/quickstart/samples-fastapi/',
                component: ComponentCreator('/docs/quickstart/samples-fastapi/', '437'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/quickstart/samples-fasthttp/',
                component: ComponentCreator('/docs/quickstart/samples-fasthttp/', '0bb'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/quickstart/samples-flask/',
                component: ComponentCreator('/docs/quickstart/samples-flask/', '9d1'),
                exact: true
              },
              {
                path: '/docs/quickstart/samples-gin/',
                component: ComponentCreator('/docs/quickstart/samples-gin/', '1db'),
                exact: true
              },
              {
                path: '/docs/quickstart/samples-java/',
                component: ComponentCreator('/docs/quickstart/samples-java/', 'b8a'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/quickstart/samples-microservices/',
                component: ComponentCreator('/docs/quickstart/samples-microservices/', 'a8b'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/quickstart/samples-mux/',
                component: ComponentCreator('/docs/quickstart/samples-mux/', 'a52'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/quickstart/samples-mysql/',
                component: ComponentCreator('/docs/quickstart/samples-mysql/', '6e1'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/quickstart/samples-nextjs/',
                component: ComponentCreator('/docs/quickstart/samples-nextjs/', 'a71'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/quickstart/samples-node-jwt/',
                component: ComponentCreator('/docs/quickstart/samples-node-jwt/', '873'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/quickstart/samples-nodejs/',
                component: ComponentCreator('/docs/quickstart/samples-nodejs/', '132'),
                exact: true
              },
              {
                path: '/docs/quickstart/samples-redis/',
                component: ComponentCreator('/docs/quickstart/samples-redis/', '5cf'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/quickstart/samples-rust-wrap/',
                component: ComponentCreator('/docs/quickstart/samples-rust-wrap/', 'f1b'),
                exact: true
              },
              {
                path: '/docs/quickstart/samples-rust/',
                component: ComponentCreator('/docs/quickstart/samples-rust/', '054'),
                exact: true
              },
              {
                path: '/docs/quickstart/samples-sse/',
                component: ComponentCreator('/docs/quickstart/samples-sse/', '241'),
                exact: true
              },
              {
                path: '/docs/quickstart/samples-typescript/',
                component: ComponentCreator('/docs/quickstart/samples-typescript/', 'bd8'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/quickstart/sanic-mongo/',
                component: ComponentCreator('/docs/quickstart/sanic-mongo/', '32b'),
                exact: true
              },
              {
                path: '/docs/running-keploy/about-api-testing/',
                component: ComponentCreator('/docs/running-keploy/about-api-testing/', '267'),
                exact: true
              },
              {
                path: '/docs/running-keploy/about-unit-testing/',
                component: ComponentCreator('/docs/running-keploy/about-unit-testing/', 'b89'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/running-keploy/agent-test-generation/',
                component: ComponentCreator('/docs/running-keploy/agent-test-generation/', '63c'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/running-keploy/api-test-architecture/',
                component: ComponentCreator('/docs/running-keploy/api-test-architecture/', '3da'),
                exact: true
              },
              {
                path: '/docs/running-keploy/api-test-generator/',
                component: ComponentCreator('/docs/running-keploy/api-test-generator/', '97f'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/running-keploy/api-testing-add-suite/',
                component: ComponentCreator('/docs/running-keploy/api-testing-add-suite/', 'b87'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/running-keploy/api-testing-adding-labels/',
                component: ComponentCreator('/docs/running-keploy/api-testing-adding-labels/', 'e0c'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/running-keploy/api-testing-assertion-tree/',
                component: ComponentCreator('/docs/running-keploy/api-testing-assertion-tree/', '4dc'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/running-keploy/api-testing-auth-setup/',
                component: ComponentCreator('/docs/running-keploy/api-testing-auth-setup/', '252'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/running-keploy/api-testing-buggy-suites/',
                component: ComponentCreator('/docs/running-keploy/api-testing-buggy-suites/', '34d'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/running-keploy/api-testing-bulk-assertions/',
                component: ComponentCreator('/docs/running-keploy/api-testing-bulk-assertions/', '2dc'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/running-keploy/api-testing-chrome-extension/',
                component: ComponentCreator('/docs/running-keploy/api-testing-chrome-extension/', 'f65'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/running-keploy/api-testing-cicd/',
                component: ComponentCreator('/docs/running-keploy/api-testing-cicd/', '619'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/running-keploy/api-testing-custom-assertions/',
                component: ComponentCreator('/docs/running-keploy/api-testing-custom-assertions/', 'f3b'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/running-keploy/api-testing-edit-assertions/',
                component: ComponentCreator('/docs/running-keploy/api-testing-edit-assertions/', '1c9'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/running-keploy/api-testing-edit-suites/',
                component: ComponentCreator('/docs/running-keploy/api-testing-edit-suites/', 'ed5'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/running-keploy/api-testing-filter-suites/',
                component: ComponentCreator('/docs/running-keploy/api-testing-filter-suites/', 'd11'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/running-keploy/api-testing-fix-with-ai/',
                component: ComponentCreator('/docs/running-keploy/api-testing-fix-with-ai/', 'b9a'),
                exact: true
              },
              {
                path: '/docs/running-keploy/api-testing-functions/',
                component: ComponentCreator('/docs/running-keploy/api-testing-functions/', 'c95'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/running-keploy/api-testing-generation-history/',
                component: ComponentCreator('/docs/running-keploy/api-testing-generation-history/', 'f6f'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/running-keploy/api-testing-local-agent/',
                component: ComponentCreator('/docs/running-keploy/api-testing-local-agent/', 'e25'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/running-keploy/api-testing-mark-unbuggy/',
                component: ComponentCreator('/docs/running-keploy/api-testing-mark-unbuggy/', 'e52'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/running-keploy/api-testing-run-report/',
                component: ComponentCreator('/docs/running-keploy/api-testing-run-report/', '0d7'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/running-keploy/api-testing-running-selective/',
                component: ComponentCreator('/docs/running-keploy/api-testing-running-selective/', '2db'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/running-keploy/api-testing-schema-coverage/',
                component: ComponentCreator('/docs/running-keploy/api-testing-schema-coverage/', '3d0'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/running-keploy/api-testing-sharing-reports/',
                component: ComponentCreator('/docs/running-keploy/api-testing-sharing-reports/', 'd6b'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/running-keploy/api-testing-suite-settings/',
                component: ComponentCreator('/docs/running-keploy/api-testing-suite-settings/', '937'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/running-keploy/api-testing-variables/',
                component: ComponentCreator('/docs/running-keploy/api-testing-variables/', '51b'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/running-keploy/api-testing-webhook/',
                component: ComponentCreator('/docs/running-keploy/api-testing-webhook/', '78e'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/running-keploy/best-practices-api-testing/',
                component: ComponentCreator('/docs/running-keploy/best-practices-api-testing/', '104'),
                exact: true
              },
              {
                path: '/docs/running-keploy/capture-loss/',
                component: ComponentCreator('/docs/running-keploy/capture-loss/', 'f44'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/running-keploy/cli-commands/',
                component: ComponentCreator('/docs/running-keploy/cli-commands/', '6ce'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/running-keploy/configuration-file/',
                component: ComponentCreator('/docs/running-keploy/configuration-file/', '963'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/running-keploy/custom-mocks/',
                component: ComponentCreator('/docs/running-keploy/custom-mocks/', 'b1a'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/running-keploy/docker-tls/',
                component: ComponentCreator('/docs/running-keploy/docker-tls/', 'b1f'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/running-keploy/generate-api-tests-using-ai/',
                component: ComponentCreator('/docs/running-keploy/generate-api-tests-using-ai/', '090'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/running-keploy/k8s-proxy-api/',
                component: ComponentCreator('/docs/running-keploy/k8s-proxy-api/', 'ec0'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/running-keploy/k8s-proxy-daemonset-architecture/',
                component: ComponentCreator('/docs/running-keploy/k8s-proxy-daemonset-architecture/', '46b'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/running-keploy/keploy-karaf-example/',
                component: ComponentCreator('/docs/running-keploy/keploy-karaf-example/', '53c'),
                exact: true
              },
              {
                path: '/docs/running-keploy/keploy-passthrough/',
                component: ComponentCreator('/docs/running-keploy/keploy-passthrough/', '59f'),
                exact: true
              },
              {
                path: '/docs/running-keploy/keploy-templatize/',
                component: ComponentCreator('/docs/running-keploy/keploy-templatize/', '32b'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/running-keploy/mock-quickstart/',
                component: ComponentCreator('/docs/running-keploy/mock-quickstart/', '168'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/running-keploy/mock-your-tests/',
                component: ComponentCreator('/docs/running-keploy/mock-your-tests/', '66f'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/running-keploy/public-api/',
                component: ComponentCreator('/docs/running-keploy/public-api/', '366'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/running-keploy/recording-filters/',
                component: ComponentCreator('/docs/running-keploy/recording-filters/', '941'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/running-keploy/rename-testcases/',
                component: ComponentCreator('/docs/running-keploy/rename-testcases/', '991'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/running-keploy/review-and-improve-ai-generated-tests/',
                component: ComponentCreator('/docs/running-keploy/review-and-improve-ai-generated-tests/', 'e1c'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/running-keploy/risk-profile-analysis/',
                component: ComponentCreator('/docs/running-keploy/risk-profile-analysis/', 'f94'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/running-keploy/run-ai-generated-api-tests/',
                component: ComponentCreator('/docs/running-keploy/run-ai-generated-api-tests/', '783'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/running-keploy/self-healing-ai-api-tests/',
                component: ComponentCreator('/docs/running-keploy/self-healing-ai-api-tests/', 'c4f'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/running-keploy/share-tests/',
                component: ComponentCreator('/docs/running-keploy/share-tests/', '6a9'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/running-keploy/test-generate/',
                component: ComponentCreator('/docs/running-keploy/test-generate/', '0fb'),
                exact: true
              },
              {
                path: '/docs/running-keploy/test-run-reports/',
                component: ComponentCreator('/docs/running-keploy/test-run-reports/', 'da5'),
                exact: true
              },
              {
                path: '/docs/running-keploy/ui-capture/',
                component: ComponentCreator('/docs/running-keploy/ui-capture/', 'd16'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/running-keploy/unit-test-architecture/',
                component: ComponentCreator('/docs/running-keploy/unit-test-architecture/', '84f'),
                exact: true
              },
              {
                path: '/docs/running-keploy/unit-test-generator/',
                component: ComponentCreator('/docs/running-keploy/unit-test-generator/', '9ee'),
                exact: true
              },
              {
                path: '/docs/running-keploy/utg-pr-agent/',
                component: ComponentCreator('/docs/running-keploy/utg-pr-agent/', 'b45'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/running-keploy/utg-vscode-extension/',
                component: ComponentCreator('/docs/running-keploy/utg-vscode-extension/', '735'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/server/',
                component: ComponentCreator('/docs/server/', 'bc8'),
                exact: true
              },
              {
                path: '/docs/server/install/',
                component: ComponentCreator('/docs/server/install/', '027'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/server/installation/',
                component: ComponentCreator('/docs/server/installation/', '905'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/server/linux/installation/',
                component: ComponentCreator('/docs/server/linux/installation/', 'da0'),
                exact: true
              },
              {
                path: '/docs/server/macos/installation/',
                component: ComponentCreator('/docs/server/macos/installation/', '9f1'),
                exact: true
              },
              {
                path: '/docs/server/sdk-installation/',
                component: ComponentCreator('/docs/server/sdk-installation/', 'd1a'),
                exact: true
              },
              {
                path: '/docs/server/sdk-installation/go/',
                component: ComponentCreator('/docs/server/sdk-installation/go/', '937'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/server/sdk-installation/java/',
                component: ComponentCreator('/docs/server/sdk-installation/java/', '8bd'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/server/sdk-installation/javascript/',
                component: ComponentCreator('/docs/server/sdk-installation/javascript/', '86f'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/server/sdk-installation/python/',
                component: ComponentCreator('/docs/server/sdk-installation/python/', '3a1'),
                exact: true,
                sidebar: "sidebarExplanation"
              },
              {
                path: '/docs/server/windows/installation/',
                component: ComponentCreator('/docs/server/windows/installation/', '075'),
                exact: true
              }
            ]
          }
        ]
      }
    ]
  },
  {
    path: '*',
    component: ComponentCreator('*'),
  },
];
